import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { getToken } from "../services/api";

// 🎓 PROTÓTIPO "PARCEIROS DE CAPACITAÇÃO" (16/10/2026).
//
// Página escondida (/parceiros/demo, sem link no menu, noindex) para o Nelson mostrar a ideia a escolas e
// professores e tentar fechar os primeiros parceiros. TUDO aqui é dado de exemplo guardado só no navegador:
// nenhum candidato real, nenhum dado pessoal, nenhuma chamada à API do eaiRH. A ÚNICA coisa real é a sala de
// vídeo (Jitsi Meet público, gratuito), para o parceiro poder fazer uma aula de teste com o Nelson na hora.
//
// Regras de desenho que o protótipo já mostra (ver mokups/parceiros-capacitacao-completo.html):
//  - o curso NUNCA cita vaga, empresa nem contratação (Procon-MG, parecer 01/2025): bloco "Quer desenvolver X?";
//  - grátis primeiro; o parceiro aparece marcado como pago;
//  - o candidato pede um horário, ele fica reservado e o PARCEIRO APROVA (ou sugere outro) em até 24h;
//  - sem gravação e sem IA na aula; presença registrada quando cada pessoa entra e sai da sala.

const PARCEIRO = {
  nome: "Ana S.",
  titulo: "Inglês para tecnologia",
  sobre: "Aulas de conversação com foco no dia a dia de tecnologia. Horários flexíveis.",
  nota: 4.9,
  alunos: 18,
  vantagem: "1ª aula grátis para cadastrados no eaiRH",
  turmas: "Conversação · terças e quintas, 20h · online",
};

const HORARIOS = ["seg 20/10 · 19h", "qua 22/10 · 20h", "qui 23/10 · 19h", "sáb 25/10 · 10h"];

function Aba({ ativa, onClick, children }) {
  return (
    <button onClick={onClick}
      className={`px-4 py-2 rounded-full text-sm font-semibold border ${ativa ? "bg-brand text-white border-brand" : "bg-white text-text border-gray-200 hover:border-brand"}`}>
      {children}
    </button>
  );
}

function Selo() {
  return <span className="inline-block border border-green-700 text-green-700 rounded-md px-2 py-0.5 text-xs font-extrabold">✓ Recomendado pelos alunos</span>;
}

function Caixa({ titulo, children, rotulo }) {
  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5 mb-5">
      {rotulo && <div className="text-[11px] font-extrabold tracking-wider text-gray-400 uppercase mb-2">{rotulo}</div>}
      {titulo && <h2 className="text-lg font-bold text-text mb-3">{titulo}</h2>}
      {children}
    </section>
  );
}

// ---------------------------------------------------------------- visão do candidato
function VisaoCandidato({ pedido, setPedido, irParaSala }) {
  const [escolhido, setEscolhido] = useState(null);
  const [autorizo, setAutorizo] = useState(false);
  const [mostrarAgenda, setMostrarAgenda] = useState(false);

  return (
    <>
      <Caixa rotulo="Na página de uma vaga, abaixo da descrição e longe do botão de candidatura">
        <div className="font-extrabold text-text">Quer desenvolver inglês?</div>
        <p className="text-sm text-gray-500 mb-3">Opções para aprender, das gratuitas para as pagas.</p>
        <div className="flex items-center justify-between gap-3 border border-gray-200 rounded-xl p-3 mb-2">
          <div><b className="block text-sm">Inglês para iniciantes</b><span className="text-xs text-gray-500">Fundação Bradesco · online</span></div>
          <span className="text-xs font-extrabold bg-green-100 text-green-800 rounded-md px-2 py-1">GRATUITO</span>
        </div>
        <div className="flex items-center justify-between gap-3 border border-gray-200 rounded-xl p-3 mb-2">
          <div><b className="block text-sm">Conversação em inglês</b><span className="text-xs text-gray-500">Plataforma de cursos · online</span></div>
          <span className="text-xs font-extrabold bg-slate-100 text-slate-700 rounded-md px-2 py-1">PAGO</span>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 border-2 border-accent bg-orange-50 rounded-xl p-3">
          <div className="flex gap-3 items-center">
            <div className="w-11 h-11 rounded-full bg-slate-200 flex items-center justify-center font-extrabold text-brand">AS</div>
            <div>
              <b className="block text-sm">{PARCEIRO.nome} · {PARCEIRO.titulo}</b>
              <span className="text-xs text-gray-500">Professora parceira · online · ★ {PARCEIRO.nota.toLocaleString("pt-BR")} ({PARCEIRO.alunos} alunos)</span>
              <div className="mt-1"><Selo /></div>
              <div className="text-xs font-bold text-brand mt-1">🎁 {PARCEIRO.vantagem}</div>
            </div>
          </div>
          <div className="text-right">
            <span className="text-xs font-extrabold bg-slate-100 text-slate-700 rounded-md px-2 py-1">PAGO</span>
            <div className="mt-2"><button onClick={() => setMostrarAgenda(true)} className="bg-accent text-white font-bold rounded-lg px-3 py-2 text-sm">Agendar aula grátis</button></div>
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-2">Parceiros são verificados pelo eaiRH e avaliados por quem fez aula. O parceiro cobra pelas aulas dele; o eaiRH não recebe nada por isso.</p>
      </Caixa>

      {mostrarAgenda && !pedido && (
        <Caixa titulo={`Aula grátis com ${PARCEIRO.nome} · 30 min · online`}>
          <div className="text-sm text-gray-500 mb-2">Horários livres esta semana</div>
          <div className="flex flex-wrap gap-2 mb-4">
            {HORARIOS.map((h) => (
              <button key={h} onClick={() => setEscolhido(h)}
                className={`px-3 py-1.5 rounded-full text-sm border ${escolhido === h ? "bg-brand text-white border-brand" : "bg-white border-gray-300"}`}>{h}</button>
            ))}
          </div>
          <div className="text-sm text-gray-500">Turmas do curso (só para você saber se cabe na rotina; matrícula direto com a professora)</div>
          <div className="text-sm mb-3">{PARCEIRO.turmas}</div>
          <label className="flex gap-2 items-start text-sm mb-3">
            <input type="checkbox" checked={autorizo} onChange={(e) => setAutorizo(e.target.checked)} className="mt-1" />
            <span>Autorizo o eaiRH a enviar meu <b>nome e WhatsApp</b> para <b>{PARCEIRO.nome}</b>, só para esta aula. Posso retirar quando quiser.</span>
          </label>
          <button disabled={!escolhido || !autorizo} onClick={() => setPedido({ horario: escolhido, status: "aguardando" })}
            className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-40">Pedir este horário</button>
        </Caixa>
      )}

      {pedido && (
        <Caixa titulo="Minha aula grátis">
          {pedido.status === "aguardando" && (
            <div className="text-sm">⏳ <b>Aguardando confirmação da {PARCEIRO.nome}</b> · {pedido.horario}. Ela confirma ou sugere outro horário em até 24 horas.
              <div className="text-xs text-gray-500 mt-1">No protótipo, abra a aba “Painel do parceiro” para aprovar.</div></div>
          )}
          {pedido.status === "sugerido" && (
            <div className="text-sm">
              <b>A {PARCEIRO.nome} sugeriu outro horário:</b> {pedido.sugestao} (no lugar de {pedido.horario}).
              <div className="flex gap-2 mt-2">
                <button onClick={() => setPedido({ horario: pedido.sugestao, status: "confirmada" })} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Aceitar</button>
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Escolher outro</button>
              </div>
            </div>
          )}
          {pedido.status === "expirada" && (
            <div className="text-sm">
              <b>A {PARCEIRO.nome} não confirmou a tempo.</b> O horário de {pedido.horario} foi liberado.
              <div className="flex gap-2 mt-2">
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Escolher outro horário</button>
                <button className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Ver outros parceiros de inglês</button>
              </div>
            </div>
          )}
          {pedido.status === "confirmada" && (
            <div className="text-sm">
              ✅ <b>Aula confirmada</b> · {pedido.horario}. Você recebe um lembrete por e-mail (e WhatsApp, se autorizou).
              <div className="flex flex-wrap gap-2 mt-2">
                <button onClick={irParaSala} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Entrar na sala de aula</button>
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Reagendar (até 12h antes)</button>
              </div>
            </div>
          )}
          {pedido.status === "realizada" && <Avaliacao />}
        </Caixa>
      )}
    </>
  );
}

function Avaliacao() {
  const [nota, setNota] = useState(0);
  const [enviada, setEnviada] = useState(false);
  const Op = ({ opcoes }) => {
    const [v, setV] = useState(null);
    return <span className="inline-flex gap-1 flex-wrap">{opcoes.map((o) => (
      <button key={o} onClick={() => setV(o)} className={`px-2.5 py-1 rounded-full text-xs border ${v === o ? "bg-brand text-white border-brand" : "border-gray-300"}`}>{o}</button>))}</span>;
  };
  if (enviada) return <div className="text-sm">Obrigado! Sua avaliação ajuda o próximo aluno a escolher bem.</div>;
  return (
    <div className="text-sm space-y-3">
      <div className="text-xs text-gray-500">Liberada só para quem esteve na sala (presença registrada).</div>
      <div>Como foi a aula com {PARCEIRO.nome}? {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} onClick={() => setNota(n)} className={`text-xl ${n <= nota ? "text-accent" : "text-gray-300"}`}>★</button>))}</div>
      <div>Você se sentiu pressionado(a) a fechar matrícula? <Op opcoes={["Não", "Um pouco", "Sim"]} /></div>
      <div>Se quisesse parar, foi (ou seria) fácil cancelar? <Op opcoes={["Sim", "Não sei", "Não"]} /></div>
      <p className="text-xs text-gray-500">“Sim” para pressão ou “Não” para cancelar pausa o parceiro na hora, até a análise do eaiRH.</p>
      <button disabled={!nota} onClick={() => setEnviada(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-40">Enviar avaliação</button>
    </div>
  );
}

// ---------------------------------------------------------------- visão do parceiro
function VisaoParceiro({ pedido, setPedido }) {
  const [enviado, setEnviado] = useState(false);
  return (
    <>
      <Caixa titulo="Painel do parceiro">
        <div className="mb-3 text-sm">Situação: <span className="bg-orange-100 text-orange-800 rounded-md px-2 py-0.5 text-xs font-extrabold">Período de teste · 2 de 5 avaliações</span></div>
        <div className="grid grid-cols-3 gap-3 mb-4">
          {[["7", "pedidos de aula grátis"], ["5", "aulas realizadas"], ["4,8 ★", "nota dos alunos"]].map(([n, t]) => (
            <div key={t} className="border border-gray-200 rounded-xl p-3"><b className="block text-2xl text-text">{n}</b><span className="text-xs text-gray-500">{t}</span></div>))}
        </div>
        {!pedido && <p className="text-sm text-gray-500">Nenhum pedido novo. (No protótipo: vá na aba “Visão do candidato”, peça um horário e volte aqui.)</p>}
        {pedido && pedido.status === "aguardando" && (
          <div className="border border-gray-200 rounded-xl p-3 text-sm">
            <b>Carla M.</b> pediu a aula grátis · {pedido.horario} · <span className="text-gray-500">expira em 23h</span>
            <div className="flex flex-wrap gap-2 mt-2">
              <button onClick={() => setPedido({ ...pedido, status: "confirmada" })} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Aprovar</button>
              <button onClick={() => setPedido({ ...pedido, status: "sugerido", sugestao: HORARIOS.find((h) => h !== pedido.horario) })} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Sugerir outro horário</button>
              <button onClick={() => setPedido({ ...pedido, status: "expirada" })} className="text-xs text-gray-500 underline">simular: não respondeu em 24h</button>
            </div>
          </div>
        )}
        {pedido && pedido.status === "confirmada" && <div className="text-sm">✅ Aula com <b>Carla M.</b> confirmada · {pedido.horario}.</div>}
        {pedido && pedido.status === "realizada" && <div className="text-sm">🟢 Aula realizada · presença registrada pela sala ✓</div>}
        <div className="mt-4 text-xs bg-orange-50 border border-orange-200 rounded-lg p-2">📅 Confirme seus horários da próxima semana até domingo, senão eles somem da sua agenda.</div>
      </Caixa>

      <Caixa titulo="Cadastro de parceiro (como o professor ou a escola entra)">
        {enviado ? <p className="text-sm">Recebido! O eaiRH confere o cadastro e avisa por e-mail. (Protótipo: nada foi enviado.)</p> : (
          <div className="grid md:grid-cols-2 gap-3 text-sm">
            <label>Nome ou escola<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="Ex.: Ana Souza" /></label>
            <label>LinkedIn ou site<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="linkedin.com/in/..." /></label>
            <label>Skills que ensina<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="Inglês, Inglês para TI" /></label>
            <label>CPF ou CNPJ (MEI)<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="obrigatório para escola" /></label>
            <label className="md:col-span-2">Vantagem para cadastrados (obrigatória)<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="1ª aula grátis, individual, sem cartão e sem contrato" /></label>
            <label className="md:col-span-2">Agenda da aula grátis<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="seg e qua 19h–21h · sáb 10h–12h" /></label>
            <label className="md:col-span-2">Turmas do curso (informativo)<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue={PARCEIRO.turmas} /></label>
            <div className="md:col-span-2 bg-slate-50 border rounded-xl p-3 text-xs leading-relaxed">
              <b>Compromissos do parceiro:</b> profissional independente, sem vínculo e sem intermediação de pagamento pelo eaiRH ·
              proibido associar o curso a vaga ou emprego, aqui ou na sua divulgação · proibido usar o nome do eaiRH sem autorização ·
              aula grátis individual, sem cartão e sem contrato · sem insistência para fechar · cancelamento simples · avaliação pública pelos alunos ·
              período de teste · responder pedidos em até 24h e cancelar só com 12h de antecedência.
            </div>
            <label className="md:col-span-2 flex gap-2 items-center"><input type="checkbox" defaultChecked /> Li e aceito os compromissos do parceiro</label>
            <div><button onClick={() => setEnviado(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2">Enviar para aprovação</button></div>
          </div>
        )}
      </Caixa>
    </>
  );
}

// ================================================================ SALAS DE AULA (17/10/2026)
// Duas salas com a MESMA tela (Nelson: "o grátis e o Cloudflare terão a mesma aparência?" — sim):
//  • AULA INDIVIDUAL — vídeo direto entre os dois navegadores (WebRTC + PeerJS). Grátis, sem conta, sem limite.
//    Feito para 2 pessoas (aguenta 3–4): cada um manda o próprio vídeo para cada um dos outros.
//  • TURMA — Cloudflare Realtime (Serverless SFU): o vídeo de cada pessoa sobe UMA vez e a Cloudflare repassa.
//    Grátis até 1.000 GB/mês (depois US$ 0,05/GB no cartão); o porteiro do eaiRH (/api/sfu) guarda o segredo,
//    conta o consumo e trava turma nova em 800 GB. Miniaturas chegam em qualidade baixa (simulcast) — economiza.
// Comuns às duas: chat, reações, levantar a mão, legenda ao vivo (com aceite LGPD), desfoque/imagem de fundo,
// escolher câmera e microfone, compartilhar tela, cronômetro, aviso de internet fraca, tela cheia.
// Chat/reações/legenda passam pelo porteiro do eaiRH, só em memória (últimas 200 por sala) — nada vai para banco.
// Sem gravação. Legenda: cada pessoa transcreve a PRÓPRIA fala pelo navegador, depois de aceitar o termo.

const PEERJS_URL = "https://cdn.jsdelivr.net/npm/peerjs@1.5.4/dist/peerjs.min.js";
const ICE_P2P = { iceServers: [{ urls: "stun:stun.l.google.com:19302" }, { urls: "stun:stun1.l.google.com:19302" }] };
// No PC de teste (localhost) as salas usam o servidor do eaiRH rodando no próprio PC (porta 5080).
const SFU = window.location.hostname === "localhost" ? "http://localhost:5080/api/sfu" : "/api/sfu";
// Turma em validação (17/10): por enquanto só aparece no PC do Nelson.
const TURMA_LIBERADA = window.location.hostname === "localhost";
// Celular (teste 17/10 com o Everton: a barra não cabia e o vídeo ficou preto). No celular: barra enxuta com "⋯",
// sem compartilhar tela (o navegador do celular não deixa), fundo desligado de início (pesa) e tela sempre acesa.
const CELULAR = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || window.innerWidth < 640;
const PODE_TELA = !!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) && !CELULAR;
const REACOES = ["👍", "❤️", "👏", "😂", "😮", "🎉"];
const novoId = () => "c" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

async function sfu(caminho, metodo = "GET", corpo) {
  const r = await fetch(SFU + caminho, {
    method: metodo,
    // vai o login junto (quando houver): criar agendamento no site no ar é só para o admin
    headers: { ...(corpo ? { "Content-Type": "application/json" } : {}), ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}) },
    body: corpo ? JSON.stringify(corpo) : undefined,
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.erro || j.errorDescription || `erro ${r.status}`);
  return j;
}

function carregarScript(url, global) {
  if (window[global]) return Promise.resolve(window[global]);
  return new Promise((ok, falha) => {
    const s = document.createElement("script");
    s.src = url; s.async = true;
    s.onload = () => ok(window[global]);
    s.onerror = () => falha(new Error("não carregou a biblioteca de vídeo"));
    document.body.appendChild(s);
  });
}

// ---------------------------------------------------------------- fundo (desfoque / imagem) — MediaPipe, no aparelho
const MP = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14";
const MODELO_FUNDO = "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite";
const FUNDOS = { nenhum: "Sem efeito", desfoque: "Desfocar", estudio: "Estúdio", eairh: "eaiRH" };
let segmentador = null;
function carregarSegmentador() {
  if (!segmentador) segmentador = (async () => {
    const vision = await import(/* webpackIgnore: true */ `${MP}/vision_bundle.mjs`);
    const arquivos = await vision.FilesetResolver.forVisionTasks(`${MP}/wasm`);
    return vision.ImageSegmenter.createFromOptions(arquivos, {
      baseOptions: { modelAssetPath: MODELO_FUNDO, delegate: "GPU" },
      runningMode: "VIDEO", outputCategoryMask: false, outputConfidenceMasks: true,
    });
  })().catch((e) => { segmentador = null; throw e; });
  return segmentador;
}

// fundo padrão do eaiRH (arte em public/fundos); carrega uma vez e fica pronto para quando a pessoa escolher
const FUNDO_EAIRH = typeof Image !== "undefined" ? Object.assign(new Image(), { src: "/fundos/eairh-padrao.jpg?v=4" }) : null;
function pintarFundo(ctx, w, h, modo, imagem) {
  if (modo === "eairh" && FUNDO_EAIRH && FUNDO_EAIRH.complete && FUNDO_EAIRH.naturalWidth) { modo = "minha"; imagem = FUNDO_EAIRH; }
  if (modo === "minha" && imagem) {          // imagem escolhida pela pessoa: preenche sem distorcer (cover)
    const esc = Math.max(w / imagem.width, h / imagem.height);
    const iw = imagem.width * esc, ih = imagem.height * esc;
    ctx.drawImage(imagem, (w - iw) / 2, (h - ih) / 2, iw, ih);
    return;
  }
  if (modo === "eairh") {
    ctx.fillStyle = "#023047"; ctx.fillRect(0, 0, w, h);
    const a = ctx.createRadialGradient(w * 0.2, h * 0.15, 0, w * 0.2, h * 0.15, w * 0.8);
    a.addColorStop(0, "rgba(0,150,199,0.55)"); a.addColorStop(1, "rgba(0,150,199,0)");
    ctx.fillStyle = a; ctx.fillRect(0, 0, w, h);
    const b = ctx.createRadialGradient(w * 0.9, h * 0.95, 0, w * 0.9, h * 0.95, w * 0.6);
    b.addColorStop(0, "rgba(251,133,0,0.25)"); b.addColorStop(1, "rgba(251,133,0,0)");
    ctx.fillStyle = b; ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = "rgba(255,255,255,0.18)";
    ctx.font = `600 ${Math.round(h / 16)}px sans-serif`; ctx.textAlign = "right";
    ctx.fillText("eaiRH", w - h / 22, h - h / 22);
    return;
  }
  // estúdio: cinza-azulado liso com luz suave no centro, como fundo de foto profissional
  const g = ctx.createRadialGradient(w / 2, h * 0.45, h * 0.05, w / 2, h / 2, w * 0.75);
  g.addColorStop(0, "#e9eef3"); g.addColorStop(1, "#9fadbb");
  ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
}

// Recebe a trilha da câmera e devolve outra trilha com o fundo trocado. `parar()` libera tudo.
async function trilhaComFundo(camera, modo, imagem) {
  const seg = await carregarSegmentador();
  if (modo === "eairh" && FUNDO_EAIRH) await FUNDO_EAIRH.decode().catch(() => {});   // arte pronta antes de pintar
  const video = document.createElement("video");
  video.srcObject = new MediaStream([camera]); video.muted = true; video.playsInline = true;
  await video.play();
  const w = video.videoWidth || 640, h = video.videoHeight || 480;
  const tela = Object.assign(document.createElement("canvas"), { width: w, height: h });
  const ctx = tela.getContext("2d");
  const fundo = Object.assign(document.createElement("canvas"), { width: w, height: h });
  if (modo !== "desfoque") pintarFundo(fundo.getContext("2d"), w, h, modo, imagem);
  const pessoa = Object.assign(document.createElement("canvas"), { width: w, height: h });
  const pctx = pessoa.getContext("2d");
  const mascara = document.createElement("canvas");
  const mctx = mascara.getContext("2d");
  let vivo = true, ultimo = -1, anterior = null;
  const passo = () => {
    if (!vivo) return;
    if (video.readyState >= 2 && video.currentTime !== ultimo) {
      ultimo = video.currentTime;
      const r = seg.segmentForVideo(video, performance.now());
      const conf = r.confidenceMasks && r.confidenceMasks[0];
      if (conf) {
        const dados = conf.getAsFloat32Array();
        if (mascara.width !== conf.width) { mascara.width = conf.width; mascara.height = conf.height; }
        const img = mctx.createImageData(conf.width, conf.height);
        if (!anterior || anterior.length !== dados.length) anterior = Float32Array.from(dados);
        for (let i = 0; i < dados.length; i++) {
          const v = dados[i] * 0.6 + anterior[i] * 0.4;          // média com o quadro anterior: borda não treme
          anterior[i] = v;
          const t = Math.min(1, Math.max(0, (v - 0.35) / 0.4));   // abaixo de 35% é fundo; acima de 75% é pessoa
          img.data[i * 4 + 3] = Math.round(t * t * (3 - 2 * t) * 255);
        }
        mctx.putImageData(img, 0, 0);
        pctx.globalCompositeOperation = "source-over";
        pctx.clearRect(0, 0, w, h); pctx.drawImage(video, 0, 0, w, h);
        pctx.globalCompositeOperation = "destination-in";
        pctx.filter = "blur(2px)"; pctx.drawImage(mascara, 0, 0, w, h); pctx.filter = "none";
        if (modo === "desfoque") { ctx.filter = "blur(14px)"; ctx.drawImage(video, 0, 0, w, h); ctx.filter = "none"; }
        else ctx.drawImage(fundo, 0, 0);
        ctx.drawImage(pessoa, 0, 0);
      }
      if (r.close) r.close();
    }
    requestAnimationFrame(passo);
  };
  requestAnimationFrame(passo);
  const trilha = tela.captureStream(30).getVideoTracks()[0];
  return { trilha, parar: () => { vivo = false; trilha.stop(); video.srcObject = null; } };
}

// ---------------------------------------------------------------- mídia local (câmera, microfone, fundo, tela)
function useMidia() {
  const [cam, setCam] = useState(null);         // trilha de vídeo que sai (já com fundo, se houver)
  const [mic, setMic] = useState(null);         // trilha de áudio
  const [telaTrilha, setTelaTrilha] = useState(null);
  const [micOn, setMicOn] = useState(true);
  const [camOn, setCamOn] = useState(true);
  const [fundo, setFundo] = useState("nenhum");
  const [carregandoFundo, setCarregandoFundo] = useState(false);
  const [aparelhos, setAparelhos] = useState({ cams: [], mics: [] });
  const [camId, setCamId] = useState("");
  const [micId, setMicId] = useState("");
  const crua = useRef(null);                    // câmera sem efeito
  const efeito = useRef(null);                  // { trilha, parar } do fundo ativo

  const listar = async () => {
    try {
      const todos = await navigator.mediaDevices.enumerateDevices();
      setAparelhos({ cams: todos.filter((d) => d.kind === "videoinput"), mics: todos.filter((d) => d.kind === "audioinput") });
    } catch { /* sem permissão ainda */ }
  };

  const imagemFundo = useRef(null);
  const versaoFundo = useRef(0);   // troca rápida de fundo: só vale o último pedido
  const aplicarFundo = async (modo, base) => {
    const minha = ++versaoFundo.current;
    if (efeito.current) { efeito.current.parar(); efeito.current = null; }
    if (modo === "nenhum") { setCam(base); return base; }
    setCarregandoFundo(true);
    try {
      const novo = await trilhaComFundo(base, modo, imagemFundo.current);
      if (minha !== versaoFundo.current) { novo.parar(); return base; }
      efeito.current = novo;
      efeito.current.trilha.enabled = base.enabled;
      setCam(efeito.current.trilha);
      return efeito.current.trilha;
    } catch {
      setFundo("nenhum"); setCam(base); return base;
    } finally { setCarregandoFundo(false); }
  };

  const iniciar = async () => {
    const s = await navigator.mediaDevices.getUserMedia({
      video: { width: { ideal: 1280 }, height: { ideal: 720 } },
      audio: { noiseSuppression: true, echoCancellation: true, autoGainControl: true },
    });
    crua.current = s.getVideoTracks()[0];
    const a = s.getAudioTracks()[0];
    setMic(a); setCam(crua.current); setMicOn(true); setCamOn(true);
    setCamId(crua.current.getSettings().deviceId || ""); setMicId(a.getSettings().deviceId || "");
    listar();
    // fundo padrão do eaiRH já ao entrar (Nelson, 17/10); entra com a câmera normal e troca quando o recorte fica pronto
    if (!CELULAR) { setFundo("eairh"); aplicarFundo("eairh", crua.current); }
    return { video: crua.current, audio: a };
  };

  const trocarCamera = async (id) => {
    const s = await navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: id }, width: { ideal: 1280 }, height: { ideal: 720 } } });
    const nova = s.getVideoTracks()[0];
    if (crua.current) crua.current.stop();
    crua.current = nova; nova.enabled = camOn; setCamId(id);
    return aplicarFundo(fundo, nova);
  };
  const trocarMic = async (id) => {
    const s = await navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: id }, noiseSuppression: true, echoCancellation: true } });
    const novo = s.getAudioTracks()[0];
    if (mic) mic.stop();
    novo.enabled = micOn; setMic(novo); setMicId(id);
    return novo;
  };
  const definirFundo = async (modo) => { setFundo(modo); return crua.current ? aplicarFundo(modo, crua.current) : null; };
  // foto escolhida pela pessoa: fica só na memória do navegador, não vai para servidor nenhum
  const usarImagem = async (arquivo) => {
    if (!arquivo || !arquivo.type.startsWith("image/")) return;
    imagemFundo.current = await createImageBitmap(arquivo);
    return definirFundo("minha");
  };
  const alternarMic = () => { if (mic) mic.enabled = !micOn; setMicOn(!micOn); };
  const alternarCam = () => {
    const ligar = !camOn;
    if (crua.current) crua.current.enabled = ligar;
    if (efeito.current) efeito.current.trilha.enabled = ligar;   // a trilha com fundo é a que vai para os outros
    setCamOn(ligar);
  };
  const comecarTela = async () => {
    const s = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false, selfBrowserSurface: "exclude", surfaceSwitching: "include" });
    const t = s.getVideoTracks()[0];
    setTelaTrilha(t);
    return t;
  };
  const pararTela = () => { if (telaTrilha) telaTrilha.stop(); setTelaTrilha(null); };
  const parar = () => {
    if (efeito.current) { efeito.current.parar(); efeito.current = null; }
    [crua.current, mic, telaTrilha].forEach((t) => t && t.stop());
    crua.current = null; setCam(null); setMic(null); setTelaTrilha(null); setFundo("nenhum");
  };

  return {
    cam, mic, telaTrilha, micOn, camOn, fundo, carregandoFundo, aparelhos, camId, micId,
    iniciar, trocarCamera, trocarMic, definirFundo, usarImagem, alternarMic, alternarCam, comecarTela, pararTela, parar,
  };
}

// ---------------------------------------------------------------- legenda ao vivo (Web Speech, com aceite)
function useLegenda(onFrase) {
  const [ligada, setLigada] = useState(false);
  const [parcial, setParcial] = useState("");   // o que está sendo dito agora (só na minha tela, na hora)
  const [erro, setErro] = useState("");
  const rec = useRef(null);
  const ativa = useRef(false);
  const Reconhecedor = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
  const ligar = () => {
    if (!Reconhecedor) return false;
    const r = new Reconhecedor();
    r.lang = "pt-BR"; r.continuous = true; r.interimResults = true;
    r.onstart = () => setErro("");
    r.onresult = (e) => {
      let meio = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const t = e.results[i][0].transcript.trim();
        if (e.results[i].isFinal) { if (t) onFrase(t); } else meio += ` ${t}`;
      }
      setParcial(meio.trim());
    };
    // erros do serviço: permissão negada desliga; rede/silêncio só tenta de novo
    r.onerror = (e) => {
      if (["not-allowed", "service-not-allowed", "audio-capture"].includes(e.error)) {
        ativa.current = false; setLigada(false); setParcial("");
        setErro(e.error === "audio-capture" ? "A legenda não achou o microfone." : "O navegador bloqueou a legenda. Libere o microfone para este site.");
      } else if (e.error === "network") setErro("A legenda perdeu a conexão; tentando de novo…");
    };
    // o Chrome encerra o reconhecimento sozinho de tempos em tempos: religa com uma pequena pausa
    r.onend = () => {
      setParcial("");
      if (ativa.current) setTimeout(() => { if (ativa.current) { try { r.start(); } catch { /* já religou */ } } }, 300);
    };
    rec.current = r; ativa.current = true;
    try { r.start(); } catch { /* já rodando */ }
    setLigada(true); setErro("");
    return true;
  };
  const desligar = () => { ativa.current = false; try { rec.current && rec.current.stop(); } catch { /* parado */ } setLigada(false); setParcial(""); };
  useEffect(() => () => { ativa.current = false; try { rec.current && rec.current.stop(); } catch { /* parado */ } }, []);
  return { ligada, ligar, desligar, parcial, erro, suportada: !!Reconhecedor };
}

// ---------------------------------------------------------------- sala compartilhada: presença, chat, mão, legenda
function useSalaComum(salaId, eu) {
  const [membros, setMembros] = useState([]);
  const [situacao, setSituacao] = useState("aberta");   // "encerrada" (professor fechou / passou do horário) ou "outro-aparelho"
  const [chat, setChat] = useState([]);
  const [legendas, setLegendas] = useState([]);   // [{id, nome, texto, em}] — as que flutuam (somem em 8 s)
  const [historicoLegendas, setHistoricoLegendas] = useState([]);   // tudo o que foi legendado nesta aula
  const [reacoes, setReacoes] = useState([]);     // [{id, nome, texto}]
  const [baloes, setBaloes] = useState([]);       // mensagens de chat recentes, mostradas sobre o vídeo
  const ultimo = useRef(0);
  const lidoAte = useRef(0);                      // maior id do chat que eu já vi com o chat aberto
  const [reacoesMsg, setReacoesMsg] = useState({}); // idDaMensagem -> { emoji: [nomes] }
  const ultimoVisto = useRef(false);
  const dados = useRef(eu);
  dados.current = eu;

  const sincronizar = async () => {
    const d = dados.current;
    if (!d.id) return;
    let r;
    try {
      r = await sfu(`/sala/${salaId}?desde=${ultimo.current}`, "POST",
        { sessionId: d.id, nome: d.nome, trilhas: d.trilhas, papel: d.papel, mao: d.mao, convite: d.convite, lidoAte: lidoAte.current });
    } catch (e) {
      // 17/10: o site reiniciou e esqueceu a sala; o vídeo direto seguiu sem dono, depois do horário. Agora sai.
      if (/não existe/i.test(e.message || "")) setSituacao("encerrada");
      return;
    }
    if (r.situacao && r.situacao !== "aberta") { setSituacao(r.situacao); return; }
    setMembros(r.membros || []);
    const novas = r.mensagens || [];
    if (!novas.length) return;
    ultimo.current = Math.max(ultimo.current, ...novas.map((m) => m.id));
    const doChat = novas.filter((m) => m.tipo === "chat" || m.tipo === "arquivo");
    setChat((c) => [...c, ...doChat].slice(-100));
    if (doChat.length && ultimoVisto.current) {   // na 1ª leitura (histórico) não pipoca balão
      setBaloes((b) => [...b, ...doChat].slice(-3));
      setTimeout(() => setBaloes((b) => b.filter((x) => !doChat.includes(x))), 7000);
    }
    ultimoVisto.current = true;
    const rmsg = novas.filter((m) => m.tipo === "reacao-msg");
    if (rmsg.length) setReacoesMsg((atual) => {
      const n = { ...atual };
      rmsg.forEach((m) => {
        const [id, emo] = m.texto.split("|");
        const por = { ...(n[id] || {}) };
        const nomes = new Set(por[emo] || []);
        if (nomes.has(m.nome)) nomes.delete(m.nome); else nomes.add(m.nome);   // reagir de novo com o mesmo = tirar
        por[emo] = [...nomes];
        n[id] = por;
      });
      return n;
    });
    const leg = novas.filter((m) => m.tipo === "legenda").map((m) => ({ ...m, chegou: Date.now() }));
    if (leg.length) { setLegendas((l) => [...l, ...leg].slice(-6)); setHistoricoLegendas((h) => [...h, ...leg].slice(-500)); }
    const rea = novas.filter((m) => m.tipo === "reacao");
    if (rea.length) {
      setReacoes((x) => [...x, ...rea]);
      setTimeout(() => setReacoes((x) => x.filter((y) => !rea.includes(y))), 3500);
    }
  };
  const marcarLido = (id) => { if (id > lidoAte.current) lidoAte.current = id; };
  const enviar = (tipo, texto) => sfu(`/sala/${salaId}/mensagem`, "POST", { sessionId: dados.current.id, nome: dados.current.nome, tipo, texto })
    .then(sincronizar).catch(() => {});
  const sair = () => { if (dados.current.id) sfu(`/sala/${salaId}/sair`, "POST", { sessionId: dados.current.id }).catch(() => {}); };
  // legendas somem da tela depois de 8 s
  useEffect(() => {
    const t = setInterval(() => setLegendas((l) => l.filter((x) => Date.now() - x.chegou < 8000)), 1000);
    return () => clearInterval(t);
  }, []);
  // material da aula: vai para o servidor (só memória) e aparece no chat para todos baixarem
  const enviarMaterial = async (arquivo) => {
    const d = dados.current;
    const f = new FormData();
    f.append("sessionId", d.id); f.append("nome", d.nome); f.append("arquivo", arquivo);
    const r = await fetch(`${SFU}/sala/${salaId}/material`, { method: "POST", body: f });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.erro || `erro ${r.status}`);
    sincronizar();
  };
  const linkMaterial = (id) => `${SFU}/sala/${salaId}/material/${id}`;
  const encerrarParaTodos = () => sfu(`/sala/${salaId}/encerrar`, "POST", { sessionId: dados.current.id }).catch(() => {});
  return { membros, chat, legendas, historicoLegendas, reacoes, reacoesMsg, marcarLido, lidoAte, baloes, situacao, sincronizar, enviar, enviarMaterial, linkMaterial, encerrarParaTodos, sair };
}

// ---------------------------------------------------------------- cronômetro e qualidade da conexão
function useCronometro(ativo) {
  const [seg, setSeg] = useState(0);
  useEffect(() => {
    if (!ativo) { setSeg(0); return undefined; }
    const ini = Date.now();
    const t = setInterval(() => setSeg(Math.floor((Date.now() - ini) / 1000)), 1000);
    return () => clearInterval(t);
  }, [ativo]);
  return `${String(Math.floor(seg / 60)).padStart(2, "0")}:${String(seg % 60).padStart(2, "0")}`;
}

async function conexaoFraca(pcs) {
  for (const pc of pcs) {
    if (!pc || pc.connectionState === "closed") continue;
    let fraca = false;
    (await pc.getStats()).forEach((s) => {
      if (s.type === "candidate-pair" && s.state === "succeeded" && s.nominated) {
        if ((s.currentRoundTripTime || 0) > 0.6) fraca = true;
        if (s.availableOutgoingBitrate && s.availableOutgoingBitrate < 250000) fraca = true;
      }
    });
    if (fraca) return true;
  }
  return false;
}

// ---------------------------------------------------------------- peças de tela comuns
// `posicao` separado do resto: "relative" e "absolute" juntos na mesma classe brigavam (print do Nelson, 17/10).
function Video({ stream, mudo, espelho, rotulo, posicao = "relative", className = "", extra = null, contain = false, onClick }) {
  const ref = useRef(null);
  // Só troca a fonte quando as FAIXAS mudam. Comparar o objeto MediaStream fazia o vídeo piscar: a sala monta um
  // MediaStream novo a cada atualização (a cada 2,5 s), e cada troca de srcObject reinicia o <video> (17/10).
  const faixas = stream ? stream.getTracks().map((t) => t.id).sort().join(",") : "";
  const [barrado, setBarrado] = useState(false);
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.srcObject = stream || null;
    if (stream) v.play().then(() => setBarrado(false)).catch(() => setBarrado(true));
  }, [faixas]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div onClick={onClick} className={`${posicao} bg-slate-900 overflow-hidden ${onClick ? "cursor-pointer" : ""} ${className}`}>
      {stream
        ? <video ref={ref} autoPlay playsInline muted={mudo} className={`w-full h-full ${contain ? "object-contain" : "object-cover"} ${espelho ? "-scale-x-100" : ""}`} />
        : <div className="absolute inset-0 flex items-center justify-center text-slate-400 text-sm px-4 text-center">Aguardando…</div>}
      {stream && barrado && (
        <button onClick={(e) => { e.stopPropagation(); ref.current && ref.current.play().then(() => setBarrado(false)).catch(() => {}); }}
          className="absolute inset-0 z-10 flex items-center justify-center bg-black/60 text-white font-bold text-sm">▶ Toque para ver e ouvir</button>
      )}
      <span className="absolute left-2 bottom-2 bg-black/60 text-white text-xs rounded px-2 py-0.5">{rotulo}</span>
      {extra}
    </div>
  );
}

// Ícones da barra (traço simples, sem biblioteca externa)
const ICONES = {
  mic: "M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5 11a7 7 0 0 0 14 0M12 18v3",
  micOff: "M3 3l18 18M9 9v3a3 3 0 0 0 5.1 2.1M15 9.3V6a3 3 0 0 0-5.9-.8M5 11a7 7 0 0 0 11.6 5.3M19 11a7 7 0 0 1-.6 2.8M12 18v3",
  cam: "M3 7h12v10H3zM15 10l6-3v10l-6-3",
  camOff: "M3 3l18 18M15 10l6-3v10l-6-3M3 7h4m4 0h4v6M3 7v10h12",
  tela: "M3 4h18v12H3zM8 20h8M12 16v4M9 10l3-3 3 3M12 7v6",
  chat: "M4 5h16v11H8l-4 4z",
  mais: "M5 12h.01M12 12h.01M19 12h.01",
  opcoes: "M4 7h10M18 7h2M4 17h4M12 17h8M14 5v4M8 15v4",
  pessoas: "M9 11a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7zM2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 6.5M18 14a6 6 0 0 1 3.5 6",
  mao: "M7 11V6a1.5 1.5 0 0 1 3 0v4M10 10V4.5a1.5 1.5 0 0 1 3 0V10M13 10V5.5a1.5 1.5 0 0 1 3 0V11M16 11V8.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7h-1a6 6 0 0 1-5-2.7L3.5 14a1.5 1.5 0 0 1 2.5-1.7L7 14V11",
  emoji: "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18zM8.5 14a4 4 0 0 0 7 0M9 9.5h.01M15 9.5h.01",
  sair: "M3 15c5-5 13-5 18 0l-2.5 2.5-3-1.5v-2.5a10 10 0 0 0-5 0V16l-3 1.5z",
  cc: "M3 5h18v14H3zM10.5 10a2.2 2.2 0 1 0 0 4M17 10a2.2 2.2 0 1 0 0 4",
  cheia: "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5",
  sairCheia: "M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5",
};
function Icone({ nome }) {
  return (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={nome === "mais" ? 3.2 : 1.9}
      strokeLinecap="round" strokeLinejoin="round"><path d={ICONES[nome]} /></svg>
  );
}

// Dica que aparece ao passar o mouse (o pai precisa de "relative group"): clara, para ler sobre o fundo escuro.
function BalaoDica({ texto, abaixo = false }) {
  return (
    <span className={`pointer-events-none absolute ${abaixo ? "top-full mt-2" : "bottom-full mb-2"} left-1/2 -translate-x-1/2 z-50 whitespace-nowrap rounded-lg bg-white text-slate-800 text-xs font-medium shadow-lg px-2.5 py-1 opacity-0 group-hover:opacity-100 group-hover:delay-300 transition`}>{texto}</span>
  );
}

// Botão redondo da barra, com nome ao passar o mouse; desligado = vermelho; ativo/aberto = azul.
function Botao({ icone, rotulo, onClick, desligado = false, aberto = false, perigo = false, contador = 0, selo = null, seloAlerta = false }) {
  const cor = perigo ? "bg-red-600 hover:bg-red-700 text-white px-5 w-auto"
    : desligado ? "bg-red-600 hover:bg-red-700 text-white"
      : aberto ? "bg-sky-200 text-slate-900"
        : "bg-slate-700 hover:bg-slate-600 text-white";
  return (
    <div className="relative group">
      <button onClick={onClick} aria-label={rotulo}
        className={`h-11 ${perigo ? "" : "w-11"} rounded-full flex items-center justify-center transition ${cor}`}>
        <Icone nome={icone} />
      </button>
      {contador > 0 && <span className="absolute -top-1 -right-1 bg-accent text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">{contador}</span>}
      {selo !== null && (   /* número fixo (ex.: pessoas na sala); amarelo quando há mão levantada */
        <span className={`absolute -top-1 -right-1 text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 ring-2 ring-slate-800 ${seloAlerta ? "bg-amber-400 text-slate-900" : "bg-sky-500 text-white"}`}>{selo}</span>
      )}
      <BalaoDica texto={rotulo} />
    </div>
  );
}

// Seção do painel lateral que abre e recolhe
function AceiteLegenda({ onAceitar, onRecusar }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-md p-5 text-sm">
        <h3 className="text-lg font-bold text-text mb-2">Ligar legenda da sua fala?</h3>
        <p className="mb-2">Sua fala será convertida em texto pelo serviço de reconhecimento de voz do seu navegador (no Chrome, <b>Google</b>; no Edge, <b>Microsoft</b>) e exibida para os participantes desta aula.</p>
        <p className="mb-2">O eaiRH <b>não grava</b> o áudio nem o texto: a legenda aparece durante a aula e não fica salva.</p>
        <p className="mb-4">Você pode desligar quando quiser.</p>
        <div className="flex gap-2 justify-end">
          <button onClick={onRecusar} className="bg-slate-100 font-bold rounded-lg px-4 py-2">Agora não</button>
          <button onClick={onAceitar} className="bg-accent text-white font-bold rounded-lg px-4 py-2">Aceito e ligar</button>
        </div>
      </div>
    </div>
  );
}

// Abre a sala numa janela própria do tamanho da tela (o navegador não deixa "maximizar" de verdade; isto é o mais
// perto). A janela entra sozinha com o nome e o papel já escolhidos. Se o navegador bloquear, entra aqui mesmo.
// Na janela própria, entra sozinho uma vez (a câmera não exige clique; o navegador só pede a permissão).
function EntrarSozinho({ ativo, entrar }) {
  const feito = useRef(false);
  useEffect(() => { if (ativo && !feito.current) { feito.current = true; entrar(); } }, [ativo]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

// Abre a sala numa janela própria do tamanho da tela. O navegador SEMPRE mostra o endereço numa janela aberta por
// um site (segurança — Meet/Zoom web também); só o eaiRH instalado como app (PWA) abre sem a barra. A janela entra
// sozinha com o nome e o papel já escolhidos. Se o navegador bloquear a janela, entra aqui mesmo.
// Papel na sala: o link manda; sem link, a conta decide (no protótipo, admin entra como professor).
const papelInicial = (doLink, user) => {
  const p = doLink.get("papel");
  if (p === "professor" || p === "aluno") return p;
  return user?.ehAdmin ? "professor" : "aluno";
};

// Erro ao compartilhar a tela: "cancelou a escolha" é silencioso; o resto aparece para a pessoa.
const avisarErroTela = (e) => {
  if (e && e.name === "NotAllowedError") return;
  console.error("compartilhar tela:", e);
  window.alert(`Não deu para compartilhar a tela: ${(e && e.message) || e}`);
};

function abrirJanelaDoConvite(token) {
  const url = `${window.location.origin}/parceiros/demo?convite=${encodeURIComponent(token)}&janela=1`;
  const w = window.screen.availWidth, h = window.screen.availHeight;
  const j = window.open(url, `aula-${token.slice(-8)}`, `popup=yes,width=${w},height=${h},left=0,top=0`);
  if (!j) window.location.href = url;
}

function abrirJanelaDaSala(link, nome, papel) {
  const url = `${link}&janela=1&nome=${encodeURIComponent((nome || "").trim())}${papel ? `&papel=${papel}` : ""}`;
  const w = window.screen.availWidth, h = window.screen.availHeight;
  const jan = window.open(url, "eairh-sala", `popup=yes,width=${w},height=${h},left=0,top=0`);
  if (!jan) window.location.href = url;
  else jan.focus();
}

// Na página, a sala fica dentro do cartão branco; na janela própria, ocupa a tela toda sem moldura.
function Moldura({ emJanela, titulo, children }) {
  return emJanela ? <div className="h-[100dvh] flex flex-col p-2 bg-slate-950">{children}</div> : <Caixa titulo={titulo}>{children}</Caixa>;
}

// Material anexado no chat: "id|nome|bytes" → cartão com o nome, o tamanho e o botão de baixar.
function CartaoMaterial({ texto, link }) {
  const [id, nome, bytes] = texto.split("|");
  if (/\.(png|jpe?g|webp)$/i.test(nome || "")) {
    return (
      <a href={link(id)} target="_blank" rel="noreferrer" className="mt-1 block">
        <img src={link(id)} alt={nome} className="max-h-48 rounded-lg border border-gray-200 bg-white" />
      </a>
    );
  }
  const tam = Number(bytes) > 1e6 ? `${(Number(bytes) / 1e6).toFixed(1).replace(".", ",")} MB` : `${Math.max(1, Math.round(Number(bytes) / 1e3))} KB`;
  return (
    <a href={link(id)} download={nome} target="_blank" rel="noreferrer"
      className="mt-1 flex items-center gap-2 rounded-lg bg-white border border-gray-200 px-2 py-1.5 hover:bg-slate-50">
      <span className="text-xl">📎</span>
      <span className="min-w-0 flex-1"><span className="block truncate font-semibold text-text">{nome}</span><span className="text-[11px] text-gray-500">{tam} · baixar</span></span>
    </a>
  );
}

// @menção no chat (Nelson, 17/10: "marcar a pessoa num comentário"). Texto puro; o destaque é só na tela.
const meMenciona = (texto, meuNome) => !!meuNome && texto.toLowerCase().includes(`@${meuNome.trim().toLowerCase()}`);
function TextoComMencoes({ texto, nomes }) {
  const alvos = nomes.filter(Boolean).map((n) => `@${n}`).sort((a, b) => b.length - a.length);
  if (!alvos.length) return texto;
  const partes = [];
  let resto = texto;
  while (resto) {
    const baixo = resto.toLowerCase();
    const achado = alvos.map((a) => ({ a, i: baixo.indexOf(a.toLowerCase()) })).filter((x) => x.i >= 0).sort((x, y) => x.i - y.i)[0];
    if (!achado) { partes.push(resto); break; }
    if (achado.i) partes.push(resto.slice(0, achado.i));
    partes.push(<b key={partes.length} className="text-brand">{resto.substr(achado.i, achado.a.length)}</b>);
    resto = resto.slice(achado.i + achado.a.length);
  }
  return partes;
}

// AGENDAR AULA DE TESTE (Nelson, 17/10): no produto o agendamento nasce do pedido aceito pelo parceiro. Aqui dá para
// criar um na mão e receber UM LINK POR PESSOA. Cada link só abre aquela sala, só no horário e só num aparelho por vez.
function AgendarTeste() {
  const { isAdmin } = useAuth();   // no site no ar, só o admin agenda turma (o servidor confere de novo)
  const [tipo, setTipo] = useState("individual");
  const [comeca, setComeca] = useState(0);
  const [duracao, setDuracao] = useState(60);
  const [professor, setProfessor] = useState("Professor Teste");
  const [alunos, setAlunos] = useState("Aluno Teste");
  const [res, setRes] = useState(null);
  const [erro, setErro] = useState("");
  const [copiado, setCopiado] = useState("");
  const criar = async () => {
    setErro(""); setRes(null);
    const lista = alunos.split("\n").map((x) => x.trim()).filter(Boolean);
    try {
      setRes(await sfu("/agendamento", "POST", {
        tipo, comecaEmMin: Number(comeca), duracaoMin: Number(duracao),
        convidados: [{ nome: professor, papel: "professor" }, ...(tipo === "individual" ? lista.slice(0, 3) : lista).map((n) => ({ nome: n, papel: "aluno" }))],
      }));
    } catch (e) { setErro(e.message); }
  };
  const linkDe = (t) => `${window.location.origin}/parceiros/demo?convite=${encodeURIComponent(t)}`;
  const hora = (d) => new Date(d).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  return (
    <div className="bg-white rounded-2xl shadow-sm p-5 text-sm">
      <h3 className="font-bold text-text text-lg">Agendar aula de teste</h3>
      <p className="text-gray-500 text-xs mt-1">No produto, isto nasce do pedido aceito pelo parceiro. Cada pessoa recebe o próprio link.</p>
      <div className="grid sm:grid-cols-3 gap-3 mt-4">
        <label className="text-xs text-gray-600">Tipo
          <select value={tipo} onChange={(e) => setTipo(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1 text-sm">
            <option value="individual">Vídeo direto (até 4 pessoas, grátis)</option>
            {(TURMA_LIBERADA || isAdmin) && <option value="turma">Turma (Cloudflare)</option>}
          </select>
        </label>
        <label className="text-xs text-gray-600">Começa
          <select value={comeca} onChange={(e) => setComeca(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1 text-sm">
            <option value={0}>Agora</option><option value={30}>Em 30 minutos</option><option value={120}>Em 2 horas</option><option value={1440}>Amanhã</option>
          </select>
        </label>
        <label className="text-xs text-gray-600">Duração
          <select value={duracao} onChange={(e) => setDuracao(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1 text-sm">
            <option value={30}>30 min</option><option value={60}>60 min</option><option value={90}>90 min</option>
          </select>
        </label>
        <label className="text-xs text-gray-600">Professor(a)
          <input value={professor} onChange={(e) => setProfessor(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1 text-sm" />
        </label>
        <label className="text-xs text-gray-600 sm:col-span-2">{tipo === "turma" ? "Alunos (um por linha)" : "Alunos (até 3, um por linha)"}
          <textarea value={alunos} onChange={(e) => setAlunos(e.target.value)} rows={3} className="w-full border rounded-lg px-2 py-1.5 mt-1 text-sm" />
        </label>
      </div>
      <button onClick={criar} className="mt-4 bg-accent text-white font-bold rounded-lg px-4 py-2">Criar agendamento</button>
      {erro && <p className="mt-3 text-red-600">{erro}</p>}
      {res && (
        <div className="mt-5">
          <p className="text-gray-600">Aula de <b>{hora(res.inicio)}</b> a <b>{hora(res.fim)}</b>. A sala abre 15 min antes; depois do fim, os links param de valer.</p>
          <ul className="mt-3 divide-y border rounded-xl">
            {res.convites.map((c) => (
              <li key={c.token} className="flex flex-wrap items-center gap-2 px-3 py-2">
                <span className="flex-1 min-w-[10rem]"><b>{c.nome}</b> <span className="text-xs text-gray-500">{c.papel === "professor" ? "professor(a)" : "aluno(a)"}</span></span>
                <button onClick={() => { navigator.clipboard && navigator.clipboard.writeText(linkDe(c.token)); setCopiado(c.token); }}
                  className="bg-slate-100 hover:bg-slate-200 font-bold rounded-lg px-3 py-1.5 text-xs">{copiado === c.token ? "✓ Copiado" : "Copiar link"}</button>
                <button onClick={() => abrirJanelaDoConvite(c.token)} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar como {c.nome.split(" ")[0]}</button>
              </li>
            ))}
          </ul>
          <p className="text-[11px] text-gray-400 mt-2">Teste: abra o mesmo link em outra janela; a primeira sai sozinha. Mexer em uma letra do link e ele deixa de abrir.</p>
        </div>
      )}
    </div>
  );
}

// Tela de AULA ENCERRADA com avaliação rápida (Nelson, 17/10). Aluno: notas (1–5) da aula, do conteúdo e da chamada + comentário.
// Professor: se o aluno veio, nota da chamada e observação privada.
// No protótipo nada é gravado; no produto real a avaliação do aluno é pública e alimenta o selo.
function Estrelas({ valor, onChange }) {
  return (
    <span className="inline-flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} className={`text-2xl leading-none ${n <= valor ? "text-accent" : "text-gray-300 hover:text-gray-400"}`}>★</button>
      ))}
    </span>
  );
}
function AulaEncerrada({ papel, emJanela, presenca = [], onFechar }) {
  const [r, setR] = useState({});
  const [enviada, setEnviada] = useState(false);
  const muda = (k) => (v) => setR((x) => ({ ...x, [k]: v }));
  const professor = papel === "professor";
  const pronto = professor ? !!r.chamada : !!(r.aula && r.conteudo && r.chamada);
  const hora = (t) => new Date(t).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  const alunos = presenca.filter((p) => p.papel !== "professor").sort((a, b) => a.entrou - b.entrou);
  const fechar = () => { if (emJanela) { window.close(); } onFechar(); };
  return (
    <div className={emJanela ? "flex-1 flex items-center justify-center p-4" : ""}>
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 text-sm mx-auto">
        <div className="text-3xl mb-1">👋</div>
        <h2 className="text-xl font-bold text-text">Aula encerrada</h2>
        {enviada ? (
          <p className="mt-2 text-gray-600">Obrigado! Sua avaliação ajuda {professor ? "a melhorar as aulas" : "o próximo aluno a escolher bem"}.</p>
        ) : professor ? (
          <div className="mt-3 space-y-3">
            <div>
              <div className="font-semibold text-text mb-1">Lista de presença ({alunos.length})</div>
              {alunos.length ? (
                <ul className="rounded-xl border border-gray-200 divide-y max-h-40 overflow-y-auto">
                  {alunos.map((a, i) => (
                    <li key={i} className="flex justify-between px-3 py-1.5">
                      <span>{a.nome}</span>
                      <span className="text-gray-500 text-xs">{hora(a.entrou)}–{hora(a.visto)} · {Math.max(1, Math.round((a.visto - a.entrou) / 60000))} min</span>
                    </li>
                  ))}
                </ul>
              ) : <p className="text-gray-500 text-xs">Nenhum aluno entrou na chamada.</p>}
              <p className="text-[11px] text-gray-400 mt-1">Preenchida sozinha com quem entrou na chamada.</p>
            </div>
            <div className="flex items-center justify-between gap-2">Qualidade da chamada (som e imagem) <Estrelas valor={r.chamada || 0} onChange={muda("chamada")} /></div>
            <textarea value={r.obs || ""} onChange={(e) => muda("obs")(e.target.value)} placeholder="Observação (opcional, só a equipe do eaiRH vê)"
              className="w-full border rounded-xl px-3 py-2" rows={2} maxLength={500} />
          </div>
        ) : (
          <div className="mt-3 space-y-3">
            <div className="flex items-center justify-between gap-2">A aula / o professor <Estrelas valor={r.aula || 0} onChange={muda("aula")} /></div>
            <div className="flex items-center justify-between gap-2">O conteúdo <Estrelas valor={r.conteudo || 0} onChange={muda("conteudo")} /></div>
            <div className="flex items-center justify-between gap-2">A chamada (som e imagem) <Estrelas valor={r.chamada || 0} onChange={muda("chamada")} /></div>
            <textarea value={r.comentario || ""} onChange={(e) => muda("comentario")(e.target.value)} placeholder="Conte como foi (opcional)"
              className="w-full border rounded-xl px-3 py-2" rows={2} maxLength={500} />
          </div>
        )}
        <div className="flex gap-2 justify-end mt-5">
          {!enviada && <button disabled={!pronto} onClick={() => setEnviada(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2 disabled:opacity-40">Enviar avaliação</button>}
          <button onClick={fechar} className="bg-slate-100 hover:bg-slate-200 font-bold rounded-lg px-4 py-2">Fechar</button>
        </div>
      </div>
    </div>
  );
}

// Tela da sala (igual nas duas). Recebe quem aparece e as ações; quem cuida do "cano" é a sala que a usa.
function PalcoAula({
  titulo, link, rotuloEntrar, fase, erro, onEntrar, nome, setNome, papel, setPapel, mostrarPapel, emJanela,
  midia, eu, remotos, destaqueId, setDestaqueId, comum, cronometro, fraca, extraRodape,
  onTrocarCamera, onTrocarMic, onFundo, onTela, onSair, mao, setMao, legenda, reserva, convite,
}) {
  const palco = useRef(null);
  // TELA CHEIA do navegador — só pelo botão em Opções (Nelson não quis automática). Esc sai.
  const raiz = useRef(null);
  const [cheio, setCheio] = useState(false);
  useEffect(() => {
    const f = () => setCheio(!!raiz.current && document.fullscreenElement === raiz.current);
    document.addEventListener("fullscreenchange", f);
    return () => document.removeEventListener("fullscreenchange", f);
  }, []);
  const imersivo = emJanela || cheio;
  const [reacoesAbertas, setReacoesAbertas] = useState(false);
  const [painel, setPainel] = useState(null);   // null | chat | mais
  const [ajuste, setAjuste] = useState(null);
  const campoChat = useRef(null);
  const focarChat = () => setTimeout(() => { const c = campoChat.current; if (c) { c.focus(); c.setSelectionRange(c.value.length, c.value.length); } }, 0);
  useEffect(() => {
    if (fase !== "dentro" || !("wakeLock" in navigator)) return undefined;
    let trava = null;
    const pedir = () => { if (document.visibilityState === "visible") navigator.wakeLock.request("screen").then((t) => { trava = t; }).catch(() => {}); };
    pedir();
    document.addEventListener("visibilitychange", pedir);
    return () => { document.removeEventListener("visibilitychange", pedir); if (trava) trava.release().catch(() => {}); };
  }, [fase]);   // setinha do mic/câmera aberta (jeito do Meet): null | "mic" | "cam"
  const alternarAjuste = (k) => { setReacoesAbertas(false); setAjuste(ajuste === k ? null : k); };
  const [caixaLegenda, setCaixaLegenda] = useState(false);
  const [enviandoMaterial, setEnviandoMaterial] = useState(false);
  const caixaRef = useRef(null);
  const [rolouParaCima, setRolouParaCima] = useState(false);
  const alternarLegenda = () => {
    // 17/10 (Nelson: "o CC não desliga"): recolher a caixa deixava a fala legendando e o CC "aberto" ligava de novo
    if (caixaLegenda || legenda.ligada) { setCaixaLegenda(false); legenda.desligar(); return; }
    setCaixaLegenda(true);
    if (legenda.suportada && !legenda.ligada) setAceite(true);
  };
  // caixa acompanha a última fala, a não ser que a pessoa tenha rolado para cima para reler
  useEffect(() => {
    const c = caixaRef.current;
    if (c && !rolouParaCima) c.scrollTop = c.scrollHeight;
  }, [comum.historicoLegendas.length, legenda.parcial, caixaLegenda]); // eslint-disable-line react-hooks/exhaustive-deps
  const [texto, setTexto] = useState("");
  const [aceite, setAceite] = useState(false);
  const entrarTelaCheia = () => {
    const el = raiz.current;
    if (!el || document.fullscreenElement) return;
    try { const r = (el.requestFullscreen || el.webkitRequestFullscreen).call(el); if (r && r.catch) r.catch(() => {}); } catch { /* navegador não deixou */ }
  };
  const telaCheia = () => { if (document.fullscreenElement) document.exitFullscreen(); else entrarTelaCheia(); };
  const [encerrada, setEncerrada] = useState(false);
  const presenca = useRef({});   // sessionId -> { nome, papel, entrou, visto }
  useEffect(() => {
    if (fase !== "dentro") return;
    const agora = Date.now();
    comum.membros.forEach((m) => {
      const p = presenca.current[m.sessionId];
      presenca.current[m.sessionId] = p ? { ...p, nome: m.nome, visto: agora } : { nome: m.nome, papel: m.papel, entrou: agora, visto: agora };
    });
  }, [comum.membros, fase]);
  const sairDaAula = () => {
    // o professor decide se a aula acaba para todos (o link de todo mundo para de valer)
    if (papel === "professor" && convite && window.confirm("Encerrar a aula para todos?\n\nOK: encerra para todos (os links param de valer).\nCancelar: só você sai.")) comum.encerrarParaTodos();
    if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
    setPainel(null); onSair(); setEncerrada(true);
  };
  const [aviso, setAviso] = useState("");
  const FECHA_EM = 30;   // segundos de aviso depois do fim, antes de fechar
  const [agora, setAgora] = useState(Date.now());
  useEffect(() => {
    if (fase !== "dentro" || !convite?.fim) return undefined;
    const t = setInterval(() => setAgora(Date.now()), 1000);
    return () => clearInterval(t);
  }, [fase, convite]);
  const restante = convite?.fim ? Math.ceil((new Date(convite.fim).getTime() - agora) / 1000) : null;   // segundos
  const mmss = (seg) => `${Math.floor(seg / 60)}:${String(seg % 60).padStart(2, "0")}`;
  useEffect(() => {
    if (fase !== "dentro" || restante === null || restante > -FECHA_EM) return;
    if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
    setPainel(null); onSair(); setEncerrada(true);
  }, [restante]); // eslint-disable-line react-hooks/exhaustive-deps
  // a sala fechou (professor encerrou ou passou do horário) ou a pessoa abriu o link em outro aparelho
  useEffect(() => {
    if (fase !== "dentro" || comum.situacao === "aberta") return;
    if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
    setPainel(null); onSair();
    if (comum.situacao === "outro-aparelho") setAviso("Você entrou nesta aula por outro aparelho, então esta janela saiu.");
    else setEncerrada(true);
  }, [comum.situacao]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (fase === "dentro") { presenca.current = {}; setEncerrada(false); } }, [fase]);
  const dentro = fase === "dentro";
  // quem apresenta vê a própria tela em destaque; a câmera fica na miniatura (Nelson, 17/10)
  const minhaTela = useMemo(() => (midia.telaTrilha ? { id: "minha-tela", nome: "Você", tela: true, stream: new MediaStream([midia.telaTrilha]) } : null), [midia.telaTrilha]);
  const destaque = minhaTela || remotos.find((r) => r.id === destaqueId) || remotos[0];
  const miniaturas = remotos.filter((r) => r !== destaque);
  const telaEmFoco = !!(destaque && destaque.tela);   // tela em destaque: nada flutua por cima dela
  const comFaixa = telaEmFoco || miniaturas.length > 0;
  const [focoEu, setFocoEu] = useState(false);   // eu no vídeo grande (para ver meu fundo, por exemplo)
  const trocado = focoEu && !telaEmFoco;
  // espelho só sem arte de fundo: com a marca do eaiRH (ou imagem própria) a pessoa vê como os outros veem, sem letra invertida
  const espelhar = !["eairh", "minha"].includes(midia.fundo);
  const mostrarLocal = useMemo(() => new MediaStream([midia.cam, midia.mic].filter(Boolean)), [midia.cam, midia.mic]);
  const [vistoAte, setVistoAte] = useState(0);
  useEffect(() => {
    if (painel !== "chat" || !comum.chat.length) return;
    const ultimoId = Math.max(...comum.chat.map((m) => m.id));
    comum.marcarLido(ultimoId); setVistoAte(ultimoId);
  }, [painel, comum.chat]); // eslint-disable-line react-hooks/exhaustive-deps
  const naoLidas = comum.chat.filter((m) => m.de !== eu.id && m.id > vistoAte).length;
  const [reagindo, setReagindo] = useState(null);   // id da mensagem com a fileira de emojis aberta
  // "lida": todos os outros na sala já viram até esta mensagem
  const lidaPorTodos = (m) => {
    const outros = comum.membros.filter((x) => x.sessionId !== eu.id);
    return outros.length > 0 && outros.every((x) => (x.lidoAte || 0) >= m.id);
  };

  return (
    <Moldura emJanela={emJanela} titulo={titulo}>
      <div ref={raiz} className={imersivo ? "h-[100dvh] flex flex-col p-2 bg-slate-950 overflow-hidden" : ""}>
      {aviso && !dentro && (
        <div className="m-auto max-w-md bg-white rounded-2xl shadow-xl p-6 text-sm">
          <div className="text-3xl mb-1">📱</div>
          <p className="text-text">{aviso}</p>
          <button onClick={() => { if (emJanela) window.close(); }} className="mt-4 bg-slate-100 hover:bg-slate-200 font-bold rounded-lg px-4 py-2">Fechar</button>
        </div>
      )}
      {!imersivo && !convite && (
        <>
          <p className="text-sm text-gray-600 mb-3">Mande este link para quem vai participar:</p>
          <div className="flex flex-wrap gap-2 items-center mb-4">
            <code className="bg-slate-100 rounded-lg px-3 py-2 text-xs break-all">{link}</code>
            <button onClick={() => navigator.clipboard && navigator.clipboard.writeText(link)} className="bg-slate-100 font-bold rounded-lg px-3 py-2 text-xs">Copiar link</button>
          </div>
        </>
      )}

      {encerrada && !dentro && <AulaEncerrada papel={papel} emJanela={emJanela} presenca={Object.values(presenca.current)} onFechar={() => setEncerrada(false)} />}
      {!encerrada && !aviso && !dentro && fase !== "entrando" && convite && (
        <div className="m-auto max-w-md bg-white rounded-2xl shadow-xl p-6 text-sm">
          <h2 className="text-lg font-bold text-text">{convite.tipo === "turma" ? "Turma" : "Aula por vídeo direto"}</h2>
          <p className="text-gray-600 mt-1">Você entra como <b>{convite.nome}</b> ({convite.papel === "professor" ? "professor(a)" : "aluno(a)"}).</p>
          {convite.situacao === "cedo" && <p className="mt-3 rounded-xl bg-amber-50 border border-amber-200 px-3 py-2">A sala abre às <b>{new Date(convite.abreEm).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}</b> de {new Date(convite.abreEm).toLocaleDateString("pt-BR")} (15 minutos antes da aula).</p>}
          {convite.situacao === "encerrada" && <p className="mt-3 rounded-xl bg-slate-50 border px-3 py-2">Esta aula já terminou. O link não vale mais.</p>}
          {convite.situacao === "aberta" && <button onClick={onEntrar} className="mt-4 bg-accent text-white font-bold rounded-lg px-4 py-2">{rotuloEntrar}</button>}
        </div>
      )}
      {!encerrada && !dentro && fase !== "entrando" && !convite && (
        <div className="flex flex-wrap gap-2 items-center">
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Seu nome na sala" className="border rounded-lg px-3 py-2 text-sm" />
          {mostrarPapel && (
            <label className={`flex items-center gap-1 text-sm ${imersivo ? "text-white" : ""}`}><input type="checkbox" checked={papel === "professor"} onChange={(e) => setPapel(e.target.checked ? "professor" : "aluno")} /> Sou o professor</label>
          )}
          <button onClick={emJanela ? onEntrar : () => abrirJanelaDaSala(link, nome, papel)} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm">{rotuloEntrar}</button>
          {!emJanela && <span className="text-xs text-gray-400">abre numa janela própria, do tamanho da tela</span>}
        </div>
      )}
      {fase === "entrando" && <p className="text-sm text-gray-600">Ligando câmera e microfone… se o navegador perguntar, clique em <b>Permitir</b>.</p>}
      {fase === "erro" && (
        <div className="mt-3 border border-red-200 bg-red-50 rounded-xl p-3 text-sm">
          {erro}
          {reserva && <div className="mt-2"><a href={reserva} target="_blank" rel="noopener noreferrer" className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-xs">Abrir sala reserva ↗</a></div>}
        </div>
      )}

      {dentro && (
        <div className="relative">
          <div className="flex-1 min-w-0 flex flex-col">
            <div ref={palco} className="relative bg-slate-900 rounded-xl overflow-hidden">
              {fraca && <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 bg-amber-500 text-white text-xs font-bold rounded-full px-3 py-1">📶 Sua internet está fraca — o vídeo pode travar</div>}
              {restante !== null && restante <= 600 && (
                <div className={`absolute top-2 left-1/2 -translate-x-1/2 z-30 rounded-full px-4 py-1.5 text-sm font-bold shadow-lg ${
                  restante <= 0 ? "bg-red-600 text-white" : restante <= 60 ? "bg-amber-500 text-white" : "bg-black/70 text-white"}`}>
                  {restante > 0
                    ? `⏳ A aula termina em ${mmss(restante)}`
                    : `⏰ Tempo esgotado. A sala fecha em ${Math.max(0, FECHA_EM + restante)} s`}
                </div>
              )}
              {telaEmFoco && (
                <div className="absolute top-2 left-2 z-20 bg-black/70 text-white text-xs font-semibold rounded-full pl-3 pr-1 py-1 flex items-center gap-2">
                  🖥️ {destaque.id === "minha-tela" ? "Você está apresentando" : `${destaque.nome} está apresentando`}
                  {destaque.id === "minha-tela"
                    ? <button onClick={onTela} className="bg-red-600 hover:bg-red-700 rounded-full px-2.5 py-0.5">Parar</button>
                    : <span className="w-1" />}
                </div>
              )}
              <div aria-hidden="true" className="pointer-events-none select-none absolute right-3 bottom-3 z-10 flex items-center gap-1.5 text-white/70 text-[11px] drop-shadow">
                <img src="/icone-eairh-branco.svg" alt="" className="h-5 opacity-80" /> Fornecido por <b className="text-white/90">eaiRH</b>
              </div>
              <Video stream={trocado ? mostrarLocal : destaque ? destaque.stream : null} mudo={trocado} espelho={trocado && espelhar} contain={trocado || !!(destaque && destaque.tela)}
                rotulo={trocado ? "Você · em destaque" : destaque ? `${destaque.nome}${destaque.tela ? " · tela" : ""}${destaque.professor ? " · professor(a)" : ""}` : "Sala aberta"}
                className={imersivo ? `w-full ${comFaixa ? "h-[calc(100dvh-11.5rem)]" : "h-[calc(100dvh-6.5rem)]"}` : "w-full aspect-video max-h-[75vh]"}
                extra={destaque && destaque.mao ? <span className="absolute right-2 bottom-2 text-2xl">✋</span> : null} />
              {trocado && (
                <div className="absolute right-3 top-3 w-[13%] min-w-[7rem] max-w-[14rem] aspect-video z-10 group">
                  <Video stream={destaque ? destaque.stream : null} rotulo={destaque ? destaque.nome : "Aguardando"} onClick={() => setFocoEu(false)}
                    className="w-full h-full rounded-lg border-2 border-white/70 shadow-lg" />
                  <BalaoDica texto="Voltar ao normal" abaixo />
                </div>
              )}
              {!telaEmFoco && !trocado && (
              <div className="absolute right-3 top-3 w-[13%] min-w-[7rem] max-w-[14rem] aspect-video z-10 group">
              <Video stream={mostrarLocal} mudo espelho={espelhar} onClick={() => setFocoEu(true)} rotulo={`${nome.trim() || "Você"}${midia.camOn ? "" : " · câmera desligada"}`}
                className="w-full h-full rounded-lg border-2 border-white/70 shadow-lg"
                extra={<>
                  {!midia.camOn && (
                    <div className="absolute inset-0 bg-slate-800 flex items-center justify-center">
                      <span className="w-12 h-12 rounded-full bg-brand text-white text-xl font-bold flex items-center justify-center">{(nome.trim() || "V").slice(0, 1).toUpperCase()}</span>
                    </div>
                  )}
                  {mao && <span className="absolute right-1 bottom-1 text-lg">✋</span>}
                </>} />
              <BalaoDica texto="Clique para me ver em destaque" abaixo />
              </div>
              )}
              {/* legenda ao vivo */}
              {caixaLegenda && (
                <div className="absolute right-3 bottom-3 z-30 w-[min(26rem,60%)] h-[42%] flex flex-col rounded-2xl bg-black/75 backdrop-blur text-white shadow-2xl p-3 text-sm">
                  <div className="flex items-center justify-between mb-2 gap-2">
                    <span className="font-bold flex items-center gap-2"><Icone nome="cc" /> Legendas</span>
                    <span className="flex items-center gap-1">
                      <button disabled={!legenda.suportada} onClick={() => (legenda.ligada ? legenda.desligar() : setAceite(true))}
                        title={legenda.suportada ? "" : "Funciona no Chrome e no Edge"}
                        className={`rounded-full px-2.5 py-1 text-xs font-semibold disabled:opacity-40 ${legenda.ligada ? "bg-sky-200 text-slate-900" : "bg-white/15 hover:bg-white/25"}`}>
                        🎙️ {legenda.ligada ? "Legendando minha fala" : "Legendar minha fala"}
                      </button>
                      <button onClick={() => setCaixaLegenda(false)} title="Recolher" aria-label="Recolher" className="w-7 h-7 rounded-full bg-white/15 hover:bg-white/25">▾</button>
                    </span>
                  </div>
                  <div ref={caixaRef} onScroll={(e) => { const c = e.currentTarget; setRolouParaCima(c.scrollHeight - c.scrollTop - c.clientHeight > 40); }}
                    className="flex-1 overflow-y-auto space-y-1.5 pr-1">
                    {comum.historicoLegendas.length === 0 && !legenda.parcial && <p className="text-white/50">As falas legendadas vão aparecer aqui e ficam guardadas até o fim da aula.</p>}
                    {comum.historicoLegendas.map((l) => (
                      <div key={l.id} className="leading-snug">
                        <span className="text-[11px] text-white/40 mr-1">{new Date(l.chegou).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}</span>
                        <b className="text-sky-200">{l.nome}:</b> {l.texto}
                      </div>
                    ))}
                    {legenda.parcial && <div className="italic text-white/70"><b>Você:</b> {legenda.parcial}…</div>}
                  </div>
                  {rolouParaCima && (
                    <button onClick={() => { setRolouParaCima(false); const c = caixaRef.current; if (c) c.scrollTop = c.scrollHeight; }}
                      className="self-center mt-1 rounded-full bg-sky-200 text-slate-900 text-xs font-semibold px-3 py-1">↓ Ir para o fim</button>
                  )}
                  {legenda.erro && <div className="mt-1 bg-amber-500 text-white text-xs font-semibold rounded-full px-3 py-1 self-center">{legenda.erro}</div>}
                </div>
              )}
              {!caixaLegenda && (comum.legendas.length > 0 || legenda.parcial || legenda.erro) && (
                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 max-w-[90%] text-center space-y-1">
                  {comum.legendas.slice(-2).map((l) => (
                    <div key={l.id} className="bg-black/75 text-white text-sm rounded px-3 py-1 inline-block"><b>{l.nome}:</b> {l.texto}</div>
                  ))}
                  {legenda.parcial && <div className="bg-black/60 text-white/90 text-sm italic rounded px-3 py-1 inline-block"><b>Você:</b> {legenda.parcial}…</div>}
                  {legenda.erro && <div className="bg-amber-500 text-white text-xs font-semibold rounded-full px-3 py-1 inline-block">{legenda.erro}</div>}
                </div>
              )}
              {/* embaixo: Chat e Pessoas lado a lado; abrir um recolhe o outro (e as Opções) — mesmo estado "painel" */}
              {painel === "chat" ? (
                <div className="absolute left-3 bottom-3 z-30 w-[min(20rem,92%)] h-[70%] flex flex-col rounded-2xl bg-white/95 backdrop-blur shadow-2xl p-3 text-sm">
                  <button onClick={() => setPainel(null)} title="Recolher" className="w-full flex items-center justify-between mb-2 rounded-xl hover:bg-slate-50 -mx-1 px-1 py-0.5">
                    <span className="font-bold text-text flex items-center gap-2"><Icone nome="chat" /> Chat da aula</span>
                    <span className="w-8 h-8 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center">▾</span>
                  </button>
                  <div className="flex-1 overflow-y-auto space-y-2 mb-2">
                    {comum.chat.length === 0 && <p className="text-gray-400">Nenhuma mensagem ainda.</p>}
                    {comum.chat.map((m) => (
                      <div key={m.id} className={`rounded-xl px-3 py-2 ${m.de === eu.id ? "bg-sky-50 ml-6" : meMenciona(m.texto, nome) ? "bg-amber-100 ring-1 ring-amber-300 mr-6" : "bg-slate-50 mr-6"}`}>
                        <div className="text-[11px] font-semibold text-gray-500">{m.de === eu.id ? "Você" : m.nome}{m.de !== eu.id && meMenciona(m.texto, nome) ? " · marcou você" : ""}</div>
                        {m.tipo === "arquivo" ? <CartaoMaterial texto={m.texto} link={comum.linkMaterial} />
                          : <TextoComMencoes texto={m.texto} nomes={comum.membros.map((x) => x.nome)} />}
                        {/* reações da mensagem + reagir; nas minhas, o "✓ lida" */}
                        <div className="flex flex-wrap items-center gap-1 mt-1">
                          {Object.entries(comum.reacoesMsg[m.id] || {}).filter(([, nomes]) => nomes.length).map(([emo, nomes]) => (
                            <button key={emo} title={nomes.join(", ")} onClick={() => comum.enviar("reacao-msg", `${m.id}|${emo}`)}
                              className={`rounded-full border px-1.5 text-xs ${nomes.includes(nome.trim() || "Convidado") ? "bg-sky-100 border-sky-300" : "bg-white border-gray-200"}`}>{emo} {nomes.length}</button>
                          ))}
                          <span className="relative">
                            <button onClick={() => setReagindo(reagindo === m.id ? null : m.id)} title="Reagir" aria-label="Reagir à mensagem"
                              className="rounded-full px-1.5 text-xs text-gray-400 hover:text-gray-700 hover:bg-white">😊+</button>
                            {reagindo === m.id && (
                              <span className="absolute bottom-full left-0 mb-1 z-10 flex gap-0.5 rounded-full bg-white shadow-lg ring-1 ring-black/5 px-1 py-0.5">
                                {REACOES.map((r) => (
                                  <button key={r} onClick={() => { comum.enviar("reacao-msg", `${m.id}|${r}`); setReagindo(null); }} className="text-lg w-7 h-7 rounded-full hover:bg-slate-100">{r}</button>
                                ))}
                              </span>
                            )}
                          </span>
                          {m.de === eu.id && (
                            <span className={`ml-auto text-[11px] ${lidaPorTodos(m) ? "text-sky-600 font-semibold" : "text-gray-400"}`}>{lidaPorTodos(m) ? "✓✓ Lida" : "✓ Enviada"}</span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  {(() => {   // sugestões de @menção
                    const m = texto.match(/@([^@\n]*)$/);
                    if (!m) return null;
                    const q = m[1].toLowerCase();
                    const lista = comum.membros.filter((x) => x.sessionId !== eu.id && x.nome.toLowerCase().startsWith(q));
                    if (!lista.length) return null;
                    return (
                      <div className="mb-1 rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
                        {lista.map((x) => (
                          <button key={x.sessionId} type="button" onClick={() => { setTexto(texto.replace(/@([^@\n]*)$/, `@${x.nome} `)); focarChat(); }}
                            className="w-full text-left px-3 py-1.5 hover:bg-slate-50">@{x.nome}</button>
                        ))}
                      </div>
                    );
                  })()}
                  <form onSubmit={(e) => { e.preventDefault(); if (texto.trim()) { comum.enviar("chat", texto.trim()); setTexto(""); } }} className="flex gap-1">
                    <label title="Anexar material (PDF, Word, Excel, PowerPoint, imagem; até 8 MB)"
                      className={`w-9 h-9 shrink-0 rounded-full flex items-center justify-center cursor-pointer ${enviandoMaterial ? "bg-slate-200 animate-pulse" : "bg-slate-100 hover:bg-slate-200"}`}>
                      📎
                      <input type="file" className="hidden" disabled={enviandoMaterial}
                        accept=".pdf,.docx,.xlsx,.pptx,.odt,.ods,.odp,.txt,.csv,.png,.jpg,.jpeg,.webp,.mp3"
                        onChange={async (e) => {
                          const f = e.target.files[0]; e.target.value = "";
                          if (!f) return;
                          if (f.size > 8_000_000) { window.alert("O arquivo deve ter até 8 MB."); return; }
                          setEnviandoMaterial(true);
                          try { await comum.enviarMaterial(f); } catch (err) { window.alert(err.message); }
                          setEnviandoMaterial(false);
                        }} />
                    </label>
                    <input ref={campoChat} value={texto} onChange={(e) => setTexto(e.target.value)}
                      onPaste={async (e) => {   // Ctrl+V de um print vai como imagem no chat (Nelson, 17/10)
                        const item = Array.from(e.clipboardData?.items || []).find((i) => i.type.startsWith("image/"));
                        if (!item) return;
                        e.preventDefault();
                        const bruto = item.getAsFile();
                        if (!bruto) return;
                        if (bruto.size > 8_000_000) { window.alert("A imagem deve ter até 8 MB."); return; }
                        const ext = bruto.type === "image/jpeg" ? "jpg" : bruto.type === "image/webp" ? "webp" : "png";
                        const f = new File([bruto], `print-${new Date().toLocaleTimeString("pt-BR").replace(/:/g, "")}.${ext}`, { type: bruto.type });
                        setEnviandoMaterial(true);
                        try { await comum.enviarMaterial(f); } catch (err) { window.alert(err.message); }
                        setEnviandoMaterial(false);
                      }} className="flex-1 min-w-0 border rounded-full px-3 py-1.5" placeholder="Mensagem… (@ marca, Ctrl+V cola print)" maxLength={500} />
                    <button className="bg-accent text-white font-bold rounded-full px-4">Enviar</button>
                  </form>
                  <p className="text-[11px] text-gray-400 mt-1">O chat não fica salvo depois da aula.</p>
                </div>
              ) : painel === "pessoas" ? (
                <div className="absolute left-3 bottom-3 z-30 w-[min(20rem,92%)] max-h-[70%] flex flex-col rounded-2xl bg-white/95 backdrop-blur shadow-2xl p-3 text-sm">
                  <button onClick={() => setPainel(null)} title="Recolher" className="w-full flex items-center justify-between mb-2 rounded-xl hover:bg-slate-50 -mx-1 px-1 py-0.5">
                    <span className="font-bold text-text flex items-center gap-2"><Icone nome="pessoas" /> Pessoas na sala ({Math.max(1, comum.membros.length)})</span>
                    <span className="w-8 h-8 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center">▾</span>
                  </button>
                  <div className="overflow-y-auto space-y-2">
                    {comum.membros.map((m) => (
                      <div key={m.sessionId} className="flex items-center gap-2">
                        <span className="w-7 h-7 rounded-full bg-brand text-white text-xs font-bold flex items-center justify-center">{(m.nome || "?").slice(0, 1).toUpperCase()}</span>
                        <span className="flex-1">{m.nome}{m.sessionId === eu.id ? " (você)" : ""}<span className="block text-[11px] text-gray-400">{m.papel === "professor" ? "Professor(a)" : "Aluno(a)"}</span></span>
                        {m.mao && <span>✋</span>}
                        {m.sessionId !== eu.id && (
                          <button onClick={() => { setTexto(`@${m.nome} `); setPainel("chat"); focarChat(); }} title={`Marcar ${m.nome} no chat`}
                            className="w-8 h-8 rounded-full bg-slate-100 hover:bg-sky-100 text-slate-600 font-bold">@</button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              {/* balões de chat sobre o vídeo (Nelson, 17/10) — só os dos outros e só com o chat fechado */}
              {painel !== "chat" && comum.baloes.filter((m) => m.de !== eu.id).length > 0 && (
                <div className="absolute left-3 bottom-12 z-20 flex flex-col gap-1.5 max-w-[60%]">
                  {comum.baloes.filter((m) => m.de !== eu.id).map((m) => (
                    <button key={m.id} onClick={() => setPainel("chat")}
                      className={`text-left text-slate-800 text-sm rounded-2xl rounded-bl-sm shadow-lg px-3 py-2 ${meMenciona(m.texto, nome) ? "bg-amber-100 ring-2 ring-amber-400" : "bg-white/95"}`}>
                      <span className="block text-[11px] font-semibold text-brand">{m.nome}{meMenciona(m.texto, nome) ? " marcou você" : ""}</span>
                      {m.tipo === "arquivo" ? `📎 ${m.texto.split("|")[1] || "material"}` : <TextoComMencoes texto={m.texto} nomes={comum.membros.map((x) => x.nome)} />}
                    </button>
                  ))}
                </div>
              )}
              {/* reações voando */}
              <div className="absolute bottom-12 right-6 z-20 flex flex-col items-end gap-1 pointer-events-none">
                {comum.reacoes.map((r) => <span key={r.id} className="text-3xl animate-bounce">{r.texto} <span className="text-xs text-white bg-black/50 rounded px-1 align-middle">{r.nome}</span></span>)}
              </div>
            </div>
            {comFaixa && (
              <div className="flex gap-2 mt-2 overflow-x-auto">
                {telaEmFoco && (
                  <Video stream={mostrarLocal} mudo espelho={espelhar} rotulo={`${nome.trim() || "Você"}${midia.camOn ? "" : " · câmera desligada"}`}
                    className="w-28 shrink-0 aspect-video rounded-lg ring-2 ring-white/60"
                    extra={<>
                      {!midia.camOn && (
                        <div className="absolute inset-0 bg-slate-800 flex items-center justify-center">
                          <span className="w-12 h-12 rounded-full bg-brand text-white text-xl font-bold flex items-center justify-center">{(nome.trim() || "V").slice(0, 1).toUpperCase()}</span>
                        </div>
                      )}
                      {mao && <span className="absolute right-1 bottom-1 text-lg">✋</span>}
                    </>} />
                )}
                {miniaturas.map((r) => (
                  <Video key={r.id} stream={r.stream} contain={!!r.tela} onClick={() => setDestaqueId(r.id)}
                    rotulo={`${r.nome}${r.tela ? " · tela" : ""}`} className="w-28 shrink-0 aspect-video rounded-lg"
                    extra={r.mao ? <span className="absolute right-1 bottom-1 text-lg">✋</span> : null} />
                ))}
              </div>
            )}
            {/* barra: só o essencial à mostra; o resto fica no painel "Mais" */}
            <div className={`relative bg-slate-800 rounded-2xl grid grid-cols-[1fr_auto_1fr] items-center ${CELULAR ? "order-first mb-2 px-2 py-2 gap-1 z-40" : "mt-3 px-4 py-3 gap-3"}`}>
              {/* ajustes da setinha: abrem acima da barra; clicar na setinha de novo recolhe */}
              {ajuste && (
                <div className={`absolute ${CELULAR ? "top-full mt-2" : "bottom-full mb-2"} left-1/2 -translate-x-1/2 z-40 w-[min(30rem,95%)] rounded-2xl bg-slate-800 text-white shadow-2xl ring-1 ring-white/10 p-3 text-sm space-y-2`}>
                  {ajuste === "mais" ? (
                    <div className="grid gap-1.5">
                      <div className="flex justify-between gap-1">
                        {REACOES.map((r) => (
                          <button key={r} onClick={() => { comum.enviar("reacao", r); setAjuste(null); }} className="text-2xl w-10 h-10 rounded-full hover:bg-slate-700">{r}</button>
                        ))}
                      </div>
                      <button onClick={() => { setMao(!mao); setAjuste(null); }} className="text-left rounded-xl px-3 py-2 bg-slate-700">✋ {mao ? "Baixar a mão" : "Levantar a mão"}</button>
                      <button onClick={() => { alternarLegenda(); setAjuste(null); }} className="text-left rounded-xl px-3 py-2 bg-slate-700">🔤 {caixaLegenda || legenda.ligada ? "Desligar legendas" : "Legendas"}</button>
                      <button onClick={() => setAjuste("cam")} className="text-left rounded-xl px-3 py-2 bg-slate-700">📷 Câmera e fundo</button>
                      <button onClick={() => setAjuste("mic")} className="text-left rounded-xl px-3 py-2 bg-slate-700">🎙️ Microfone</button>
                    </div>
                  ) : ajuste === "mic" ? (
                    <>
                      <label className="flex items-center gap-2 rounded-full ring-1 ring-white/25 px-3 py-1.5">
                        <Icone nome="mic" />
                        <select value={midia.micId} onChange={(e) => onTrocarMic(e.target.value)} className="flex-1 min-w-0 bg-transparent outline-none text-sm">
                          {midia.aparelhos.mics.map((d, i) => <option key={d.deviceId} value={d.deviceId} className="text-slate-900">{d.label || `Microfone ${i + 1}`}</option>)}
                        </select>
                      </label>
                      <p className="text-[11px] text-slate-400 px-1">Redução de ruído e de eco ligadas.</p>
                    </>
                  ) : (
                    <>
                      <label className="flex items-center gap-2 rounded-full ring-1 ring-white/25 px-3 py-1.5">
                        <Icone nome="cam" />
                        <select value={midia.camId} onChange={(e) => onTrocarCamera(e.target.value)} className="flex-1 min-w-0 bg-transparent outline-none text-sm">
                          {midia.aparelhos.cams.map((d, i) => <option key={d.deviceId} value={d.deviceId} className="text-slate-900">{d.label || `Câmera ${i + 1}`}</option>)}
                        </select>
                      </label>
                      <div className="flex flex-wrap gap-1.5">
                        {Object.entries(FUNDOS).map(([k, v]) => (
                          <button key={k} onClick={() => onFundo(k)} className={`rounded-full px-3 py-1.5 text-xs ${midia.fundo === k ? "bg-sky-200 text-slate-900" : "bg-slate-700 hover:bg-slate-600"}`}>{v}</button>
                        ))}
                        <label className={`rounded-full px-3 py-1.5 text-xs cursor-pointer ${midia.fundo === "minha" ? "bg-sky-200 text-slate-900" : "bg-slate-700 hover:bg-slate-600"}`}>
                          🖼️ Imagem minha
                          <input type="file" accept="image/*" className="hidden" onChange={(e) => { midia.usarImagem(e.target.files[0]); e.target.value = ""; }} />
                        </label>
                      </div>
                      <p className="text-[11px] text-slate-400 px-1">Fundo {midia.carregandoFundo ? "carregando…" : "feito no seu aparelho; a imagem não sai dele."}</p>
                    </>
                  )}
                </div>
              )}
              <div className="justify-self-start flex items-center gap-3 text-xs text-slate-300">
                <span className="hidden sm:inline">⏱️ {cronometro}</span>
                {/* Pessoas fica aqui, à esquerda, clicável (Nelson, 17/10); amarelo quando alguém levanta a mão */}
                <span className="relative group">
                <button onClick={() => setPainel(painel === "pessoas" ? null : "pessoas")}
                  className={`rounded px-1 transition ${painel === "pessoas" ? "text-sky-200" : comum.membros.some((m) => m.mao) ? "text-amber-300" : "text-slate-300 hover:text-white"}`}>
                  👥 {Math.max(1, comum.membros.length)}{comum.membros.some((m) => m.mao) ? " ✋" : ""}
                </button>
                  <BalaoDica texto="Ver quem está na sala" />
                </span>
              </div>
              <div className={`col-start-2 flex items-center justify-center ${CELULAR ? "gap-2" : "gap-3"}`}>
                <div className={`flex items-center rounded-full ${CELULAR ? "" : "bg-slate-700/50"}`}>
                  <span className={`relative group ${CELULAR ? "hidden" : ""}`}>
                    <button onClick={() => alternarAjuste("mic")} className={`w-8 h-11 rounded-l-full text-xs ${ajuste === "mic" ? "text-sky-200" : "text-slate-300 hover:text-white"}`}>{ajuste === "mic" ? "▾" : "▴"}</button>
                    <BalaoDica texto="Ajustes do microfone" />
                  </span>
                  <Botao icone={midia.micOn ? "mic" : "micOff"} rotulo={midia.micOn ? "Desligar microfone" : "Ligar microfone"} desligado={!midia.micOn} onClick={midia.alternarMic} />
                </div>
                <div className={`flex items-center rounded-full ${CELULAR ? "" : "bg-slate-700/50"}`}>
                  <span className={`relative group ${CELULAR ? "hidden" : ""}`}>
                    <button onClick={() => alternarAjuste("cam")} className={`w-8 h-11 rounded-l-full text-xs ${ajuste === "cam" ? "text-sky-200" : "text-slate-300 hover:text-white"}`}>{ajuste === "cam" ? "▾" : "▴"}</button>
                    <BalaoDica texto="Ajustes da câmera e fundo" />
                  </span>
                  <Botao icone={midia.camOn ? "cam" : "camOff"} rotulo={midia.camOn ? "Desligar câmera" : "Ligar câmera"} desligado={!midia.camOn} onClick={midia.alternarCam} />
                </div>
                {PODE_TELA && <Botao icone="tela" rotulo={midia.telaTrilha ? "Parar de compartilhar a tela" : "Compartilhar a tela"} aberto={!!midia.telaTrilha} onClick={onTela} />}
                {!CELULAR && <Botao icone="mao" rotulo={mao ? "Baixar a mão" : "Levantar a mão"} aberto={mao} onClick={() => setMao(!mao)} />}
                <div className={`relative ${CELULAR ? "hidden" : ""}`}>
                  <Botao icone="emoji" rotulo="Reações" aberto={reacoesAbertas} onClick={() => { setAjuste(null); setReacoesAbertas(!reacoesAbertas); }} />
                  {reacoesAbertas && (
                    <div className="absolute bottom-14 left-1/2 -translate-x-1/2 z-40 flex gap-1 rounded-full bg-white shadow-2xl px-2 py-1.5">
                      {REACOES.map((r) => (
                        <button key={r} onClick={() => { comum.enviar("reacao", r); setReacoesAbertas(false); }}
                          className="text-2xl w-10 h-10 rounded-full hover:bg-slate-100 hover:scale-110 transition">{r}</button>
                      ))}
                    </div>
                  )}
                </div>
                {!CELULAR && <Botao icone="cc" rotulo={caixaLegenda || legenda.ligada ? "Desligar legendas" : "Legendas"} aberto={caixaLegenda || legenda.ligada} onClick={alternarLegenda} />}
                {!CELULAR && <Botao icone={cheio ? "sairCheia" : "cheia"} rotulo={cheio ? "Sair da tela cheia" : "Tela cheia"} aberto={cheio} onClick={telaCheia} />}
                <Botao icone="chat" rotulo="Chat" aberto={painel === "chat"} contador={painel === "chat" ? 0 : naoLidas}
                  onClick={() => setPainel(painel === "chat" ? null : "chat")} />
                {CELULAR && <Botao icone="mais" rotulo="Mais opções" aberto={ajuste === "mais" || mao} onClick={() => alternarAjuste("mais")} />}
              </div>
              <div className="justify-self-end"><Botao icone="sair" rotulo="Sair da aula" perigo onClick={sairDaAula} /></div>
            </div>
            {!imersivo && extraRodape}
          </div>

        </div>
      )}

      {aceite && <AceiteLegenda onRecusar={() => setAceite(false)} onAceitar={() => { setAceite(false); legenda.ligar(); }} />}
      </div>
    </Moldura>
  );
}

// ---------------------------------------------------------------- AULA INDIVIDUAL (vídeo direto)
function SalaDeAula({ sala, onRealizada, emJanela, convite }) {
  // VÍDEO DIRETO ATÉ 4 (Nelson, 17/10: "só para testes, validar o limite"). Cada um liga direto para cada um
  // (malha). Para não ligarem os dois ao mesmo tempo, quem tem o id "menor" é quem chama. Com 3 ou 4 pessoas,
  // cada envio cai para ~500 kbps e metade da resolução, senão a internet de casa não aguenta mandar 3 vídeos.
  const { user } = useAuth();
  const doLink = new URLSearchParams(window.location.search);
  const [nome, setNome] = useState(convite?.nome || doLink.get("nome") || user?.nome || "");   // com link pessoal, o nome vem dele
  const [papel, setPapel] = useState(convite?.papel || papelInicial(doLink, user));
  const [fase, setFase] = useState("fora");
  const [erro, setErro] = useState("");
  const [streams, setStreams] = useState({});   // sessionId -> vídeo que chega de cada um
  const [destaqueId, setDestaqueId] = useState(null);
  const [mao, setMao] = useState(false);
  const [fraca, setFraca] = useState(false);
  const midia = useMidia();
  const meuId = useRef(novoId());
  const peerRef = useRef(null);
  const chamadas = useRef({});                  // sessionId -> { call, em }
  const saindo = useRef(trilhasQueSaem());
  const salaId = sala;
  const peerDe = (sid) => `eairh-${sala}-${sid}`;
  const comum = useSalaComum(salaId, { id: fase === "dentro" ? meuId.current : null, nome: nome.trim() || "Convidado", trilhas: midia.telaTrilha ? ["tela"] : [], papel, mao, convite: convite?.token });
  const legenda = useLegenda((t) => comum.enviar("legenda", t));
  const cronometro = useCronometro(fase === "dentro");
  const link = `${window.location.origin}/parceiros/demo?sala=${sala}`;

  // o que sai agora (câmera com fundo, ou a tela) — vale para chamadas novas e é trocado nas que já existem
  useEffect(() => { saindo.current.video = midia.telaTrilha || midia.cam; trocarEmTodas("video", saindo.current.video); }, [midia.cam, midia.telaTrilha]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { saindo.current.audio = midia.mic; trocarEmTodas("audio", midia.mic); }, [midia.mic]); // eslint-disable-line react-hooks/exhaustive-deps
  const meuStream = () => new MediaStream([saindo.current.video, saindo.current.audio].filter(Boolean));
  const conexoes = () => Object.values(chamadas.current).map((c) => c.call.peerConnection).filter((pc) => pc && pc.signalingState !== "closed");
  function trocarEmTodas(tipo, trilha) {
    if (!trilha) return;
    conexoes().forEach((pc) => {
      const snd = pc.getSenders().find((x) => x.track && x.track.kind === tipo);
      if (snd) snd.replaceTrack(trilha).catch(() => {});
    });
  }
  // 2 pessoas: qualidade cheia; 3 ou 4: cada envio mais leve
  const ajustarQualidade = () => {
    const muitos = conexoes().length >= 2;
    conexoes().forEach((pc) => pc.getSenders().filter((x) => x.track && x.track.kind === "video").forEach((snd) => {
      const prm = snd.getParameters();
      if (!prm.encodings || !prm.encodings.length) prm.encodings = [{}];
      prm.encodings[0].maxBitrate = muitos ? 500_000 : 1_500_000;
      prm.encodings[0].scaleResolutionDownBy = muitos && !midia.telaTrilha ? 2 : 1;
      snd.setParameters(prm).catch(() => {});
    }));
  };

  const largar = (sid) => {
    const c = chamadas.current[sid];
    if (c) { try { c.call.close(); } catch { /* já fechada */ } delete chamadas.current[sid]; }
    setStreams((m) => { if (!m[sid]) return m; const n = { ...m }; delete n[sid]; return n; });
  };
  const ligar = (sid, call) => {
    if (chamadas.current[sid] && chamadas.current[sid].call !== call) largar(sid);
    chamadas.current[sid] = { call, em: Date.now() };
    call.on("stream", (st) => { setStreams((m) => ({ ...m, [sid]: st })); setTimeout(ajustarQualidade, 1000); });
    call.on("close", () => { if (chamadas.current[sid] && chamadas.current[sid].call === call) largar(sid); });
    call.on("error", () => largar(sid));
  };

  const entrar = async () => {
    setErro(""); setFase("entrando");
    let trilhas;
    try { trilhas = await midia.iniciar(); }
    catch { setErro("Não deu acesso à câmera e ao microfone. Libere no navegador e tente de novo."); setFase("erro"); return; }
    saindo.current = { video: trilhas.video, audio: trilhas.audio };
    try {
      const Peer = await carregarScript(PEERJS_URL, "Peer");
      const eu = new Peer(peerDe(meuId.current), { config: ICE_P2P });
      peerRef.current = eu;
      eu.on("open", () => setFase("dentro"));
      eu.on("call", (call) => {
        const sid = call.metadata && call.metadata.sid;
        if (!sid) { call.close(); return; }
        call.answer(meuStream()); ligar(sid, call);
      });
      // "peer-unavailable": a outra pessoa ainda não abriu — a próxima sincronização tenta de novo
      eu.on("error", (e) => { if (e.type !== "peer-unavailable") { setErro("Não conseguimos conectar à sala."); setFase("erro"); } });
    } catch (e) { setErro(e.message); setFase("erro"); }
  };

  // a cada lista de presença: liga para quem chegou (se eu for o "menor"), larga quem saiu, refaz o que travou
  useEffect(() => {
    if (fase !== "dentro" || !peerRef.current) return;
    const outros = comum.membros.filter((m) => m.sessionId !== meuId.current).slice(0, 3).map((m) => m.sessionId);
    Object.keys(chamadas.current).forEach((sid) => { if (!outros.includes(sid)) largar(sid); });
    outros.forEach((sid) => {
      const c = chamadas.current[sid];
      if (c && !streams[sid] && Date.now() - c.em > 12000) largar(sid);   // pendurou: tenta de novo
      if (!chamadas.current[sid] && meuId.current < sid)
        ligar(sid, peerRef.current.call(peerDe(sid), meuStream(), { metadata: { sid: meuId.current } }));
    });
  }, [comum.membros, fase]); // eslint-disable-line react-hooks/exhaustive-deps

  const sair = () => {
    comum.sair(); legenda.desligar();
    Object.keys(chamadas.current).forEach(largar);
    try { peerRef.current && peerRef.current.destroy(); } catch { /* já fechado */ }
    peerRef.current = null;
    midia.parar(); setStreams({}); setMao(false); setFase("fora");
  };
  useEffect(() => () => { try { peerRef.current && peerRef.current.destroy(); } catch { /* */ } }, []);

  // presença/chat a cada 2,5 s e qualidade da conexão a cada 5 s
  useEffect(() => {
    if (fase !== "dentro") return undefined;
    comum.sincronizar();
    const a = setInterval(comum.sincronizar, 2500);
    const b = setInterval(async () => setFraca(await conexaoFraca(conexoes())), 5000);
    return () => { clearInterval(a); clearInterval(b); };
  }, [fase]); // eslint-disable-line react-hooks/exhaustive-deps

  const remotos = comum.membros.filter((m) => m.sessionId !== meuId.current).slice(0, 3).map((m) => ({
    id: m.sessionId, nome: m.nome, stream: streams[m.sessionId] || null, mao: m.mao,
    professor: m.papel === "professor", tela: (m.trilhas || []).includes("tela"),
  }));
  // destaque: quem a pessoa escolheu; senão quem está apresentando; senão o professor; senão o primeiro
  const destaqueEfetivo = (remotos.find((r) => r.id === destaqueId) || remotos.find((r) => r.tela) || remotos.find((r) => r.professor) || remotos[0] || {}).id;

  return (
    <>
      <EntrarSozinho ativo={emJanela && (!convite || convite.situacao === "aberta")} entrar={entrar} />
      <PalcoAula titulo="Vídeo direto (grátis, até 4 pessoas)" link={link} rotuloEntrar="Entrar na sala" fase={fase} erro={erro} convite={convite}
        onEntrar={entrar} nome={nome} setNome={setNome} papel={papel} setPapel={setPapel} mostrarPapel={!convite} emJanela={emJanela}
        midia={midia} eu={{ id: meuId.current }} remotos={remotos} destaqueId={destaqueEfetivo} setDestaqueId={setDestaqueId}
        comum={comum} cronometro={cronometro} fraca={fraca} mao={mao} setMao={setMao} legenda={legenda}
        reserva={`https://meet.jit.si/eairh-aula-${sala}`}
        onTrocarCamera={(id) => midia.trocarCamera(id)} onTrocarMic={(id) => midia.trocarMic(id)}
        onFundo={(m) => midia.definirFundo(m)}
        onTela={() => (midia.telaTrilha ? midia.pararTela() : midia.comecarTela().then((t) => { t.onended = () => midia.pararTela(); }).catch(avisarErroTela))}
        onSair={sair} />
    </>
  );
}
const trilhasQueSaem = () => ({ video: null, audio: null });

// ---------------------------------------------------------------- TURMA (Cloudflare Realtime)
function SalaTurma({ sala, emJanela, convite }) {
  const { user } = useAuth();
  const doLink = new URLSearchParams(window.location.search);
  const [nome, setNome] = useState(convite?.nome || doLink.get("nome") || user?.nome || "");   // com link pessoal, o nome vem dele
  const [papel, setPapel] = useState(convite?.papel || papelInicial(doLink, user));
  const [fase, setFase] = useState("fora");
  const [erro, setErro] = useState("");
  const [mao, setMao] = useState(false);
  const [gb, setGb] = useState(null);
  const [fraca, setFraca] = useState(false);
  const [streams, setStreams] = useState({});      // "sessionId:trilha" -> MediaStream
  const [destaqueId, setDestaqueId] = useState(null);
  const [minhasTrilhas, setMinhasTrilhas] = useState(["audio", "video"]);
  const midia = useMidia();
  const pcRef = useRef(null);
  const meuId = useRef(null);
  const assinadas = useRef(new Set());             // "sessionId:trilha" já pedidas
  const midDe = useRef({});                         // "sessionId:trilha" -> mid
  const donoDoMid = useRef({});                     // mid -> "sessionId:trilha"
  const qualidade = useRef({});                     // mid -> rid pedido
  const fila = useRef(Promise.resolve());
  const transVideo = useRef(null);
  const transAudio = useRef(null);
  const transTela = useRef(null);
  const numTela = useRef(0);
  const ultimoBytes = useRef(0);
  const salaId = sala;
  const link = `${window.location.origin}/parceiros/demo?sala=${sala}&modo=turma`;
  const comum = useSalaComum(salaId, { id: fase === "dentro" ? meuId.current : null, nome: nome.trim() || "Convidado", trilhas: minhasTrilhas, papel, mao, convite: convite?.token });
  const legenda = useLegenda((t) => comum.enviar("legenda", t));
  const cronometro = useCronometro(fase === "dentro");

  // uma negociação por vez; um erro numa delas não derruba a página nem trava as próximas
  const emFila = (fn) => { fila.current = fila.current.then(fn, fn).catch(() => {}); return fila.current; };

  const renegociar = async (r) => {
    const pc = pcRef.current;
    if (!r.requiresImmediateRenegotiation || !r.sessionDescription) return;
    await pc.setRemoteDescription(r.sessionDescription);
    const resposta = await pc.createAnswer();
    await pc.setLocalDescription(resposta);
    await sfu(`/sessao/${meuId.current}/renegociar`, "PUT", { sessionDescription: { type: "answer", sdp: resposta.sdp } });
  };

  // assina as trilhas de alguém (vídeo em qualidade baixa de início; o destaque sobe depois)
  const assinar = (m) => emFila(async () => {
    if (!pcRef.current) return;
    const faltam = (m.trilhas || []).filter((t) => !assinadas.current.has(`${m.sessionId}:${t}`));
    if (!faltam.length) return;
    faltam.forEach((t) => assinadas.current.add(`${m.sessionId}:${t}`));
    try {
      const r = await sfu(`/sessao/${meuId.current}/trilhas`, "POST", {
        tracks: faltam.map((t) => (t === "video"
          ? { location: "remote", sessionId: m.sessionId, trackName: t, simulcast: { preferredRid: "q", priorityOrdering: "asciibetical", ridNotAvailable: "asciibetical" } }
          : { location: "remote", sessionId: m.sessionId, trackName: t })),
      });
      (r.tracks || []).forEach((t) => {
        const chave = `${t.sessionId || m.sessionId}:${t.trackName}`;
        if (t.errorCode || !t.mid) { assinadas.current.delete(chave); return; }
        midDe.current[chave] = t.mid; donoDoMid.current[t.mid] = chave;
        if (t.trackName === "video") qualidade.current[t.mid] = "q";
      });
      await renegociar(r);
    } catch { faltam.forEach((t) => assinadas.current.delete(`${m.sessionId}:${t}`)); }
  });

  // publica a minha tela como trilha nova "tela-N"
  const publicarTela = (trilha) => emFila(async () => { try {
    const pc = pcRef.current;
    // conexão já encerrada (caiu ou a aula terminou): não publica e devolve a tela
    if (!pc || pc.signalingState === "closed") { trilha.stop(); midia.pararTela(); return; }
    numTela.current += 1;
    const nomeTrilha = `tela-${numTela.current}`;
    const tr = pc.addTransceiver(trilha, { direction: "sendonly" });
    transTela.current = tr;
    const oferta = await pc.createOffer();
    await pc.setLocalDescription(oferta);
    const r = await sfu(`/sessao/${meuId.current}/trilhas`, "POST", {
      sessionDescription: { type: "offer", sdp: oferta.sdp },
      tracks: [{ location: "local", mid: tr.mid, trackName: nomeTrilha }],
    });
    await pc.setRemoteDescription(r.sessionDescription);
    setMinhasTrilhas(["audio", "video", nomeTrilha]);
  } catch (e) { trilha.stop(); midia.pararTela(); avisarErroTela(e); } });
  const pararTela = () => {
    if (transTela.current && pcRef.current && pcRef.current.signalingState !== "closed") transTela.current.sender.replaceTrack(null).catch(() => {});
    transTela.current = null;
    setMinhasTrilhas(["audio", "video"]);
    midia.pararTela();
  };

  const medirConsumo = async () => {
    const pc = pcRef.current;
    if (!pc) return;
    let total = 0;
    (await pc.getStats()).forEach((s) => { if (s.type === "inbound-rtp") total += s.bytesReceived || 0; });
    const delta = total - ultimoBytes.current;
    ultimoBytes.current = total;
    if (delta > 0) { try { const r = await sfu("/consumo", "POST", { bytes: delta }); setGb(r.gbMes); } catch { /* próximo minuto */ } }
  };

  const entrar = async () => {
    setErro(""); setFase("entrando");
    try {
      const sit = await sfu("/situacao");
      if (!sit.configurado) throw new Error("A sala de turma ainda não foi configurada no painel admin.");
      if (!sit.liberado) throw new Error("Limite de vídeo do mês atingido. Use a sala reserva.");
      setGb(sit.gbMes);
      const trilhas = await midia.iniciar();
      const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.cloudflare.com:3478" }], bundlePolicy: "max-bundle" });
      pcRef.current = pc;
      pc.ontrack = (e) => {
        const chave = donoDoMid.current[e.transceiver.mid];
        if (!chave) return;
        setStreams((s) => ({ ...s, [chave]: new MediaStream([e.track]) }));
      };
      pc.oniceconnectionstatechange = () => {
        if (pc.iceConnectionState === "failed") { setErro("A conexão de vídeo caiu nesta rede."); setFase("erro"); }
      };
      const { sessionId } = await sfu(`/sessao?convite=${encodeURIComponent(convite?.token || "")}`, "POST");
      meuId.current = sessionId;
      transAudio.current = pc.addTransceiver(trilhas.audio, { direction: "sendonly" });
      // simulcast: 3 qualidades do mesmo vídeo; quem vê em miniatura recebe a "q" (leve)
      transVideo.current = pc.addTransceiver(trilhas.video, {
        direction: "sendonly",
        sendEncodings: [
          { rid: "f", maxBitrate: 1200000 },
          { rid: "h", scaleResolutionDownBy: 2, maxBitrate: 450000 },
          { rid: "q", scaleResolutionDownBy: 4, maxBitrate: 150000 },
        ],
      });
      const oferta = await pc.createOffer();
      await pc.setLocalDescription(oferta);
      const r = await sfu(`/sessao/${sessionId}/trilhas`, "POST", {
        sessionDescription: { type: "offer", sdp: oferta.sdp },
        tracks: [
          { location: "local", mid: transAudio.current.mid, trackName: "audio" },
          { location: "local", mid: transVideo.current.mid, trackName: "video" },
        ],
      });
      await pc.setRemoteDescription(r.sessionDescription);
      setFase("dentro");
    } catch (e) { setErro(e.message || "Não conseguimos entrar na turma."); setFase("erro"); limpar(); }
  };

  const limpar = () => {
    try { pcRef.current && pcRef.current.close(); } catch { /* já fechada */ }
    pcRef.current = null; meuId.current = null;
    assinadas.current = new Set(); midDe.current = {}; donoDoMid.current = {}; qualidade.current = {};
    transTela.current = null; transVideo.current = null; transAudio.current = null; ultimoBytes.current = 0;
    midia.parar(); setStreams({}); setMinhasTrilhas(["audio", "video"]);
  };
  const sair = () => { medirConsumo(); comum.sair(); legenda.desligar(); limpar(); setMao(false); setFase("fora"); };
  useEffect(() => () => { try { pcRef.current && pcRef.current.close(); } catch { /* */ } }, []);

  // trocas de câmera/fundo/microfone vão para a mesma trilha publicada (sem renegociar)
  const trocarTrilha = (tr, trilha) => {
    const pc = pcRef.current;
    if (!tr || !trilha || !pc || pc.signalingState === "closed") return;
    tr.sender.replaceTrack(trilha).catch(() => {});
  };
  useEffect(() => { trocarTrilha(transVideo.current, midia.cam); }, [midia.cam]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { trocarTrilha(transAudio.current, midia.mic); }, [midia.mic]); // eslint-disable-line react-hooks/exhaustive-deps

  // presença: assina quem chegou, esquece quem saiu
  useEffect(() => {
    if (fase !== "dentro") return;
    const presentes = new Set();
    comum.membros.forEach((m) => {
      if (m.sessionId === meuId.current) return;
      (m.trilhas || []).forEach((t) => presentes.add(`${m.sessionId}:${t}`));
      assinar(m);
    });
    Object.keys(midDe.current).forEach((k) => {
      if (!presentes.has(k)) { delete donoDoMid.current[midDe.current[k]]; delete midDe.current[k]; assinadas.current.delete(k); }
    });
    setStreams((s) => { const n = {}; Object.keys(s).forEach((k) => { if (presentes.has(k)) n[k] = s[k]; }); return n; });
  }, [comum.membros, fase]); // eslint-disable-line react-hooks/exhaustive-deps

  // timers: presença/chat 2,5 s · consumo 60 s · conexão 5 s
  useEffect(() => {
    if (fase !== "dentro") return undefined;
    comum.sincronizar();
    const a = setInterval(comum.sincronizar, 2500);
    const b = setInterval(medirConsumo, 60000);
    const c = setInterval(async () => setFraca(await conexaoFraca([pcRef.current])), 5000);
    return () => { clearInterval(a); clearInterval(b); clearInterval(c); };
  }, [fase]); // eslint-disable-line react-hooks/exhaustive-deps

  // monta quem aparece: cada pessoa (vídeo+áudio) e cada tela compartilhada como "pessoa" à parte
  const remotos = [];
  comum.membros.filter((m) => m.sessionId !== meuId.current).forEach((m) => {
    const v = streams[`${m.sessionId}:video`], a = streams[`${m.sessionId}:audio`];
    const faixas = [...(v ? v.getTracks() : []), ...(a ? a.getTracks() : [])];
    remotos.push({ id: m.sessionId, nome: m.nome, mao: m.mao, professor: m.papel === "professor", stream: faixas.length ? new MediaStream(faixas) : null });
    (m.trilhas || []).filter((t) => t.startsWith("tela-")).forEach((t) => {
      const s = streams[`${m.sessionId}:${t}`];
      remotos.push({ id: `${m.sessionId}:${t}`, nome: m.nome, tela: true, stream: s || null });
    });
  });
  // destaque automático: tela compartilhada > professor > quem a pessoa clicou > primeiro
  const autoDestaque = (remotos.find((r) => r.tela) || remotos.find((r) => r.professor) || remotos[0] || {}).id;
  const destaqueEfetivo = remotos.some((r) => r.id === destaqueId) ? destaqueId : autoDestaque;

  // qualidade: o vídeo em destaque sobe para "f"; os demais ficam em "q"
  useEffect(() => {
    if (fase !== "dentro") return;
    const mudar = [];
    comum.membros.forEach((m) => {
      const mid = midDe.current[`${m.sessionId}:video`];
      if (!mid) return;
      const quer = m.sessionId === destaqueEfetivo ? "f" : "q";
      if (qualidade.current[mid] !== quer) {
        qualidade.current[mid] = quer;
        mudar.push({ location: "remote", sessionId: m.sessionId, trackName: "video", mid, simulcast: { preferredRid: quer, priorityOrdering: "asciibetical", ridNotAvailable: "asciibetical" } });
      }
    });
    if (mudar.length) emFila(async () => { try { await renegociar(await sfu(`/sessao/${meuId.current}/atualizar`, "PUT", { tracks: mudar })); } catch { /* fica como está */ } });
  }, [destaqueEfetivo, comum.membros, streams, fase]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
    <EntrarSozinho ativo={emJanela && (!convite || convite.situacao === "aberta")} entrar={entrar} />
    <PalcoAula titulo="Turma (vários alunos) — pela Cloudflare" link={link} rotuloEntrar="Entrar na turma" fase={fase} erro={erro} convite={convite}
      onEntrar={entrar} nome={nome} setNome={setNome} papel={papel} setPapel={setPapel} mostrarPapel={!convite} emJanela={emJanela}
      midia={midia} eu={{ id: meuId.current }} remotos={remotos} destaqueId={destaqueEfetivo} setDestaqueId={setDestaqueId}
      comum={comum} cronometro={cronometro} fraca={fraca} mao={mao} setMao={setMao} legenda={legenda}
      onTrocarCamera={(id) => midia.trocarCamera(id)} onTrocarMic={(id) => midia.trocarMic(id)}
      onFundo={(m) => midia.definirFundo(m)}
      onTela={() => (midia.telaTrilha ? pararTela() : midia.comecarTela().then((t) => { t.onended = () => pararTela(); return publicarTela(t); }).catch(avisarErroTela))}
      onSair={sair}
      extraRodape={<p className="text-xs text-gray-500 mt-2 text-center">{remotos.filter((r) => !r.tela).length + 1} na turma{gb !== null ? ` · vídeo usado no mês: ${Number(gb).toFixed(2)} GB de 1.000 GB grátis` : ""} · clique numa miniatura para pôr em destaque</p>} />
    </>
  );
}

// ---------------------------------------------------------------- página
export default function ParceirosDemoPage() {
  const params = new URLSearchParams(window.location.search);
  const sala = useMemo(() => params.get("sala") || Math.random().toString(36).slice(2, 8), []); // eslint-disable-line react-hooks/exhaustive-deps
  const [aba, setAba] = useState(params.get("sala") ? "sala" : "candidato");
  const [modo, setModo] = useState(params.get("modo") === "turma" ? "turma" : "individual");
  const [pedido, setPedido] = useState(null);

  useEffect(() => {
    document.title = "Parceiros de capacitação · protótipo · eaiRH";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  // Link pessoal: descobre de quem é, que sala abre e se está no horário.
  const tokenConvite = params.get("convite");
  const [convite, setConvite] = useState(null);
  const [erroConvite, setErroConvite] = useState("");
  useEffect(() => {
    if (!tokenConvite) return;
    sfu(`/convite/${encodeURIComponent(tokenConvite)}`).then((c) => setConvite({ ...c, token: tokenConvite })).catch((e) => setErroConvite(e.message));
  }, [tokenConvite]);
  if (tokenConvite) {
    return (
      <div className="min-h-screen bg-slate-950 flex flex-col">
        {erroConvite ? (
          <div className="m-auto max-w-md bg-white rounded-2xl shadow-xl p-6 text-sm"><div className="text-3xl mb-1">🔒</div><p>{erroConvite}</p>
            <p className="text-gray-500 text-xs mt-2">Peça um novo link a quem agendou a aula.</p></div>
        ) : !convite ? <p className="m-auto text-slate-300 text-sm">Conferindo o seu link…</p>
          : convite.tipo === "turma"
            ? <SalaTurma sala={convite.sala} convite={convite} emJanela />
            : <SalaDeAula sala={convite.sala} convite={convite} emJanela onRealizada={() => {}} />}
      </div>
    );
  }

  // Janela própria da sala: só a sala, sem menu nem abas. Ao sair, a janela fecha.
  if (params.get("janela") === "1") {
    if (params.has("nome") || params.has("papel")) {
      const curto = new URLSearchParams(window.location.search);
      curto.delete("nome"); curto.delete("papel");
      window.history.replaceState(null, "", `${window.location.pathname}?${curto.toString()}`);
    }
    return (
      <div className="min-h-screen bg-slate-950">
        {modo === "turma" && TURMA_LIBERADA
          ? <SalaTurma sala={sala} emJanela />
          : <SalaDeAula sala={sala} emJanela onRealizada={() => {}} />}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <div className="bg-brand text-white rounded-2xl p-6 mb-6">
          <div className="text-xs font-extrabold tracking-widest uppercase text-orange-300">Protótipo · dados de exemplo</div>
          <h1 className="text-2xl md:text-3xl font-bold mt-1">Parceiros de capacitação</h1>
          <p className="text-sm text-blue-100 mt-2 max-w-2xl">Quem procura emprego no eaiRH e quer desenvolver uma skill (como inglês ou Excel) encontra professores e escolas
            verificados, avaliados pelos próprios alunos, com uma aula grátis agendada e feita dentro do portal. Grátis para o aluno, sem comissão para o parceiro.</p>
          <div className="grid grid-cols-3 gap-3 mt-4 text-center">
            {[["2.254", "vagas abertas pedem Excel"], ["1.775", "vagas abertas pedem inglês"], ["R$ 0", "de comissão para o parceiro"]].map(([n, t]) => (
              <div key={t} className="bg-white/10 rounded-xl p-3"><b className="block text-2xl text-orange-300">{n}</b><span className="text-xs text-blue-100">{t}</span></div>))}
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-5">
          <Aba ativa={aba === "candidato"} onClick={() => setAba("candidato")}>Visão do candidato</Aba>
          <Aba ativa={aba === "parceiro"} onClick={() => setAba("parceiro")}>Painel do parceiro</Aba>
          <Aba ativa={aba === "sala"} onClick={() => setAba("sala")}>Sala de aula</Aba>
        </div>

        {aba === "candidato" && <VisaoCandidato pedido={pedido} setPedido={setPedido} irParaSala={() => setAba("sala")} />}
        {aba === "parceiro" && <VisaoParceiro pedido={pedido} setPedido={setPedido} />}
        {aba === "sala" && <AgendarTeste />}
        {false && (
          <>
            {/* Turma em validação (17/10): por enquanto só aparece no PC do Nelson (localhost). */}
            {TURMA_LIBERADA && (
              <div className="flex flex-wrap gap-2 mb-3">
                <Aba ativa={modo === "individual"} onClick={() => setModo("individual")}>Aula individual (vídeo direto)</Aba>
                <Aba ativa={modo === "turma"} onClick={() => setModo("turma")}>Turma (vários alunos)</Aba>
              </div>
            )}
            {modo === "individual" || !TURMA_LIBERADA
              ? <SalaDeAula sala={sala} onRealizada={() => setPedido((p) => (p ? { ...p, status: "realizada" } : p))} />
              : <SalaTurma sala={sala} />}
          </>
        )}

        <p className="text-xs text-gray-400 text-center mt-8">Protótipo para conversa com parceiros. Nada aqui é enviado nem gravado, exceto a sala de vídeo, que é real.</p>
      </main>
    </div>
  );
}
